{
  "about.blocks": "Eingeschränkte Server",
  "about.contact": "Kontakt:",
  "about.default_locale": "Standard",
  "about.disclaimer": "Mastodon ist eine freie, quelloffene Software und eine Marke der Mastodon GmbH.",
  "about.domain_blocks.no_reason_available": "Keinen Grund angegeben",
  "about.domain_blocks.preamble": "Mastodon erlaubt es dir grundsätzlich, alle Inhalte von allen Nutzer*innen auf allen Servern im Fediverse zu sehen und mit ihnen zu interagieren. Für diesen Server gibt es aber ein paar Ausnahmen.",
  "about.domain_blocks.silenced.explanation": "Standardmäßig werden von diesem Server keine Inhalte oder Profile angezeigt. Du kannst die Profile und Inhalte aber dennoch sehen, wenn du explizit nach diesen suchst oder diesen folgst.",
  "about.domain_blocks.silenced.title": "Stummgeschaltet",
  "about.domain_blocks.suspended.explanation": "Es werden keine Daten von diesem Server verarbeitet, gespeichert oder ausgetauscht, sodass eine Interaktion oder Kommunikation mit Profilen dieses Servers nicht möglich ist.",
  "about.domain_blocks.suspended.title": "Gesperrt",
  "about.language_label": "Sprache",
  "about.not_available": "Diese Informationen sind auf diesem Server nicht verfügbar.",
  "about.powered_by": "Ein dezentralisiertes soziales Netzwerk, ermöglicht durch {mastodon}",
  "about.rules": "Serverregeln",
  "account.account_note_header": "Persönliche Notiz",
  "account.activity": "Aktivitäten",
  "account.add_note": "Persönliche Notiz hinzufügen",
  "account.add_or_remove_from_list": "Listen verwalten",
  "account.badges.admin": "Admin",
  "account.badges.blocked": "Blockiert",
  "account.badges.bot": "Bot",
  "account.badges.domain_blocked": "Domain blockiert",
  "account.badges.group": "Gruppe",
  "account.badges.muted": "Stummgeschaltet",
  "account.badges.muted_until": "Stummgeschaltet bis {until}",
  "account.block": "@{name} blockieren",
  "account.block_domain": "{domain} blockieren",
  "account.block_short": "Blockieren",
  "account.blocked": "Blockiert",
  "account.cancel_follow_request": "Anfrage zurückziehen",
  "account.copy": "Link zum Profil kopieren",
  "account.direct": "@{name} privat erwähnen",
  "account.disable_notifications": "Benachrichtige mich nicht mehr, wenn @{name} etwas veröffentlicht",
  "account.edit_note": "Persönliche Notiz bearbeiten",
  "account.edit_profile": "Profil bearbeiten",
  "account.edit_profile_short": "Bearbeiten",
  "account.enable_notifications": "Benachrichtige mich, wenn @{name} etwas veröffentlicht",
  "account.endorse": "Im Profil vorstellen",
  "account.familiar_followers_many": "Gefolgt von {name1}, {name2} und {othersCount, plural, one {einem weiteren Profil, das dir bekannt ist} other {# weiteren Profilen, die dir bekannt sind}}",
  "account.familiar_followers_one": "Gefolgt von {name1}",
  "account.familiar_followers_two": "Gefolgt von {name1} und {name2}",
  "account.featured": "Vorgestellt",
  "account.featured.accounts": "Profile",
  "account.featured.collections": "Sammlungen",
  "account.featured.new_collection": "Neue Sammlung",
  "account.field_overflow": "Vollständigen Inhalt anzeigen",
  "account.filters.all": "Alle Aktivitäten",
  "account.filters.boosts_toggle": "Geteilte Beiträge anzeigen",
  "account.filters.posts_boosts": "Beiträge & geteilte Beiträge",
  "account.filters.posts_only": "Beiträge",
  "account.filters.posts_replies": "Beiträge & Antworten",
  "account.filters.replies_toggle": "Antworten anzeigen",
  "account.follow": "Folgen",
  "account.follow_back": "Ebenfalls folgen",
  "account.follow_back_short": "Zurückfolgen",
  "account.follow_request": "Folgen anfragen",
  "account.follow_request_cancel": "Anfrage zurückziehen",
  "account.follow_request_cancel_short": "Abbrechen",
  "account.follow_request_short": "Anfragen",
  "account.followers": "Follower",
  "account.followers.empty": "Diesem Profil folgt noch niemand.",
  "account.followers_counter": "{count, plural, one {{counter} Follower} other {{counter} Follower}}",
  "account.followers_you_know_counter": "{counter} bekannt",
  "account.following": "Folge ich",
  "account.following_counter": "{count, plural, one {{counter} Folge ich} other {{counter} Folge ich}}",
  "account.follows.empty": "Dieses Profil folgt noch niemandem.",
  "account.follows_you": "Folgt dir",
  "account.go_to_profile": "Profil aufrufen",
  "account.hide_reblogs": "Geteilte Beiträge von @{name} ausblenden",
  "account.in_memoriam": "Zum Andenken.",
  "account.join_modal.day": "Tag",
  "account.join_modal.me": "Du bist auf {server} dabei seit",
  "account.join_modal.me_anniversary": "Alles Gute zum Fediläum! Auf {server} bist du seit",
  "account.join_modal.me_today": "Dein erster Tag auf {server}!",
  "account.join_modal.other": "{name} ist auf {server} dabei seit",
  "account.join_modal.other_today": "{name} ist seit einem Tag auf {server}!",
  "account.join_modal.share.celebrate": "Teile die Feierlichkeit",
  "account.join_modal.share.intro": "Teile einen Einblick über dich",
  "account.join_modal.share.welcome": "Teile ein herzliches Willkommen",
  "account.join_modal.years": "{number, plural, one {Jahr} other {Jahre}}",
  "account.joined_short": "Dabei seit",
  "account.languages": "Sprachen verwalten",
  "account.last_active": "Zuletzt aktiv",
  "account.link_verified_on": "Dieser Link wurde am {date} Uhr verifiziert",
  "account.locked_info": "Die Privatsphäre dieses Kontos wurde auf „geschützt“ gesetzt. Die Person bestimmt manuell, wer ihrem Profil folgen darf.",
  "account.media": "Medien",
  "account.mention": "@{name} erwähnen",
  "account.menu.add_to_collection": "Einer Sammlung hinzufügen …",
  "account.menu.add_to_list": "Einer Liste hinzufügen …",
  "account.menu.block": "Konto blockieren",
  "account.menu.block_domain": "{domain} blockieren",
  "account.menu.copied": "Profillink in die Zwischenablage kopiert",
  "account.menu.copy": "Profillink kopieren",
  "account.menu.direct": "Privat erwähnen",
  "account.menu.hide_reblogs": "Geteilte Beiträge in der Timeline ausblenden",
  "account.menu.mention": "Erwähnen",
  "account.menu.mute": "Konto stummschalten",
  "account.menu.note.description": "Nur für dich sichtbar",
  "account.menu.open_original_page": "Auf {domain} ansehen",
  "account.menu.remove_follower": "Follower entfernen",
  "account.menu.report": "Konto melden",
  "account.menu.share": "Teilen …",
  "account.menu.show_reblogs": "Geteilte Beiträge in der Timeline anzeigen",
  "account.menu.unblock": "Blockierung aufheben",
  "account.menu.unblock_domain": "Blockierung von {domain} aufheben",
  "account.menu.unmute": "Stummschaltung aufheben",
  "account.moved_to": "{name} hat angegeben, dass dieses das neue Konto ist:",
  "account.mute": "@{name} stummschalten",
  "account.mute_notifications_short": "Benachrichtigungen stummschalten",
  "account.mute_short": "Stummschalten",
  "account.muted": "Stummgeschaltet",
  "account.mutual": "Ihr folgt einander",
  "account.name.copy": "Adresse kopieren",
  "account.name.help.domain": "{domain} ist der Server, auf dem dieser Profilname registriert ist und dessen Inhalte sich befinden.",
  "account.name.help.domain_self": "{domain} ist der Server, auf dem du registriert bist und deine Beiträge verwaltet werden.",
  "account.name.help.footer": "So wie du E-Mails an andere trotz unterschiedlicher E-Mail-Provider senden kannst, so kannst du auch mit anderen Profilen auf unterschiedlichen Mastodon-Servern interagieren – das funktioniert auch bei allen Fediverse-Apps!",
  "account.name.help.header": "Die Fediverse-Adresse ähnelt einer E-Mail-Adresse",
  "account.name.help.username": "{username} ist ein einmaliger Profilname auf diesem Server. Es ist möglich, dass jemand auf einem anderen Server den gleichen Profilnamen hat.",
  "account.name.help.username_self": "{username} ist dein Profilname auf diesem Server. Es ist möglich, dass jemand auf einem anderen Server den gleichen Profilnamen hat.",
  "account.name_info": "Was bedeutet das?",
  "account.no_bio": "Keine Beschreibung verfügbar.",
  "account.node_modal.callout": "Persönliche Notizen sind nur für dich sichtbar.",
  "account.node_modal.edit_title": "Persönliche Notiz bearbeiten",
  "account.node_modal.error_unknown": "Persönliche Notiz konnte nicht gespeichert werden",
  "account.node_modal.field_label": "Persönliche Notiz",
  "account.node_modal.save": "Speichern",
  "account.node_modal.title": "Persönliche Notiz hinzufügen",
  "account.note.edit_button": "Bearbeiten",
  "account.note.title": "Persönliche Notiz (nur für dich sichtbar)",
  "account.open_original_page": "Originalseite öffnen",
  "account.pending": "Ausstehend",
  "account.posts": "Beiträge",
  "account.remove_from_followers": "@{name} als Follower entfernen",
  "account.report": "@{name} melden",
  "account.requested_follow": "{name} möchte dir folgen",
  "account.share": "Profil von @{name} teilen",
  "account.show_reblogs": "Geteilte Beiträge von @{name} anzeigen",
  "account.statuses_counter": "{count, plural, one {{counter} Beitrag} other {{counter} Beiträge}}",
  "account.timeline.pinned": "Angeheftet",
  "account.timeline.pinned.view_all": "Alle angehefteten Beiträge anzeigen",
  "account.unblock": "Blockierung von {name} aufheben",
  "account.unblock_domain": "Blockierung von {domain} aufheben",
  "account.unblock_domain_short": "Blockierung aufheben",
  "account.unblock_short": "Blockierung aufheben",
  "account.unendorse": "Im Profil nicht mehr vorstellen",
  "account.unfollow": "Entfolgen",
  "account.unmute": "Stummschaltung von @{name} aufheben",
  "account.unmute_notifications_short": "Stummschaltung der Benachrichtigungen aufheben",
  "account.unmute_short": "Stummschaltung aufheben",
  "account_edit.advanced_settings.bot_hint": "Signalisiert anderen, dass dieses Konto vor allem automatisierte Aktionen durchführt und möglicherweise nicht persönlich betreut oder moderiert wird",
  "account_edit.advanced_settings.bot_label": "Automatisiertes Konto",
  "account_edit.advanced_settings.title": "Erweiterte Einstellungen",
  "account_edit.bio.add_label": "Biografie hinzufügen",
  "account_edit.bio.edit_label": "Biografie bearbeiten",
  "account_edit.bio.placeholder": "Gib anderen einen Einblick über dich, damit sie wissen, wer du bist.",
  "account_edit.bio.title": "Über mich",
  "account_edit.bio_modal.add_title": "Biografie hinzufügen",
  "account_edit.bio_modal.edit_title": "Biografie bearbeiten",
  "account_edit.column_button": "Erledigt",
  "account_edit.column_title": "Profil bearbeiten",
  "account_edit.custom_fields.add_label": "Zusatzfeld hinzufügen",
  "account_edit.custom_fields.edit_label": "Zusatzfeld bearbeiten",
  "account_edit.custom_fields.placeholder": "Ergänze deine Pronomen, weiterführenden Links oder etwas anderes, das du teilen möchtest.",
  "account_edit.custom_fields.reorder_button": "Felder neu anordnen",
  "account_edit.custom_fields.tip_content": "Du kannst deine Echtheit im Mastodon-Profil beweisen, wenn du verifizierte Links zu deinen Websites bereitstellst.",
  "account_edit.custom_fields.tip_title": "Tipp: Ergänze verifizierte Links",
  "account_edit.custom_fields.title": "Zusatzfelder",
  "account_edit.custom_fields.verified_hint": "Wie erstelle ich einen verifizierten Link?",
  "account_edit.display_name.add_label": "Anzeigenamen hinzufügen",
  "account_edit.display_name.edit_label": "Anzeigenamen bearbeiten",
  "account_edit.display_name.placeholder": "Dein Anzeigename wird auf deinem Profil und in Timelines angezeigt.",
  "account_edit.display_name.title": "Anzeigename",
  "account_edit.featured_hashtags.edit_label": "Hashtags hinzufügen",
  "account_edit.featured_hashtags.placeholder": "Präsentiere deine Lieblingsthemen und ermögliche anderen einen schnellen Zugriff darauf.",
  "account_edit.featured_hashtags.title": "Vorgestellte Hashtags",
  "account_edit.field_actions.delete": "Zusatzfeld löschen",
  "account_edit.field_actions.edit": "Zusatzfeld bearbeiten",
  "account_edit.field_delete_modal.confirm": "Möchtest du dieses Zusatzfeld wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "account_edit.field_delete_modal.delete_button": "Löschen",
  "account_edit.field_delete_modal.title": "Zusatzfeld löschen?",
  "account_edit.field_edit_modal.add_title": "Zusatzfeld hinzufügen",
  "account_edit.field_edit_modal.discard_confirm": "Verwerfen",
  "account_edit.field_edit_modal.discard_message": "Du hast Änderungen vorgenommen, die noch nicht gespeichert sind. Trotzdem verwerfen?",
  "account_edit.field_edit_modal.edit_title": "Zusatzfeld bearbeiten",
  "account_edit.field_edit_modal.length_warning": "Empfohlene Zeichenanzahl überschritten. Auf mobilen Geräten wird dieses Feld möglicherweise nicht vollständig angezeigt.",
  "account_edit.field_edit_modal.link_emoji_warning": "Das Verwenden von Emojis wird bei URLs nicht empfohlen. Die Zusatzfelder werden bei dieser Kombination nur als Text und nicht als Link dargestellt.",
  "account_edit.field_edit_modal.name_hint": "z. B. „Meine Website“",
  "account_edit.field_edit_modal.name_label": "Beschriftung",
  "account_edit.field_edit_modal.url_warning": "Um einen Link hinzuzufügen, füge {protocol} an den Anfang ein.",
  "account_edit.field_edit_modal.value_hint": "z. B. „https://beispiel.tld“",
  "account_edit.field_edit_modal.value_label": "Inhalt",
  "account_edit.field_reorder_modal.drag_cancel": "Das Ziehen wurde abgebrochen und das Feld „{item}“ wurde abgelegt.",
  "account_edit.field_reorder_modal.drag_end": "Das Feld „{item}“ wurde abgelegt.",
  "account_edit.field_reorder_modal.drag_instructions": "Drücke zum Anordnen der Zusatzfelder die Eingabe- oder Leertaste. Verwende beim Ziehen die Pfeiltasten, um es hoch oder runter zu bewegen. Drücke erneut die Eingabe- oder Leertaste, um das Zusatzfeld an der gewünschten Position abzulegen. Mit der Escape-Taste kannst du den Vorgang abbrechen.",
  "account_edit.field_reorder_modal.drag_move": "Das Feld „{item}“ wurde verschoben.",
  "account_edit.field_reorder_modal.drag_over": "Das Feld „{item}“ wurde über „{over}“ verschoben.",
  "account_edit.field_reorder_modal.drag_start": "Das Feld „{item}“ wurde ausgewählt.",
  "account_edit.field_reorder_modal.handle_label": "Das Feld „{item}“ verschieben",
  "account_edit.field_reorder_modal.title": "Felder neu anordnen",
  "account_edit.image_alt_modal.add_title": "Bildbeschreibung hinzufügen",
  "account_edit.image_alt_modal.details_content": "Richtig: <ul> <li>Beschreibe dich selbst wie abgebildet</li> <li>Verwende beim Beschreiben die 3. Person (z. B. „Axel“ anstatt „ich“)</li> <li>Formuliere kurz und knackig – ein paar Wörter sind ausreichend</li> </ul> Falsch: <ul> <li>Mit „Bild von“ beginnen – bei Screenreadern überflüssig</li> </ul> Korrektes Beispiel: <ul> <li>„Axel trägt ein grünes T-Shirt und eine Brille.“</li> </ul>",
  "account_edit.image_alt_modal.details_title": "Hinweis: Bildbeschreibung für Profilbilder",
  "account_edit.image_alt_modal.edit_title": "Bildbeschreibung bearbeiten",
  "account_edit.image_alt_modal.text_hint": "Bildbeschreibungen können sehbehinderten oder blinden Menschen helfen, deine Medieninhalte mithilfe eines Screenreaders besser zu verstehen und einzuordnen.",
  "account_edit.image_alt_modal.text_label": "Bildbeschreibung",
  "account_edit.image_delete_modal.confirm": "Möchtest du dieses Bild wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
  "account_edit.image_delete_modal.delete_button": "Löschen",
  "account_edit.image_delete_modal.title": "Bild löschen?",
  "account_edit.image_edit.add_button": "Bild hinzufügen",
  "account_edit.image_edit.alt_add_button": "Bildbeschreibung hinzufügen",
  "account_edit.image_edit.alt_edit_button": "Bildbeschreibung bearbeiten",
  "account_edit.image_edit.remove_button": "Bild entfernen",
  "account_edit.image_edit.replace_button": "Bild ersetzen",
  "account_edit.item_list.delete": "{name} löschen",
  "account_edit.item_list.edit": "{name} bearbeiten",
  "account_edit.name_modal.add_title": "Anzeigenamen hinzufügen",
  "account_edit.name_modal.edit_title": "Anzeigenamen bearbeiten",
  "account_edit.profile_tab.button_label": "Anpassen",
  "account_edit.profile_tab.hint.description": "Diese Einstellungen legen fest, was andere in den offiziellen Apps auf {server} sehen können. Möglicherweise werden sie nicht von anderen Servern oder Apps von Dritten berücksichtigt.",
  "account_edit.profile_tab.hint.title": "Darstellung kann abweichen",
  "account_edit.profile_tab.show_featured.description": "„Vorgestellt“ ist ein optionaler Tab, der von dir ausgewählte Profile hervorhebt.",
  "account_edit.profile_tab.show_featured.title": "„Vorgestellt“-Tab anzeigen",
  "account_edit.profile_tab.show_media.description": "„Medien“ ist ein optionaler Tab, der deine Beiträge mit Audio, Bildern oder Videos anzeigt.",
  "account_edit.profile_tab.show_media.title": "„Medien“-Tab anzeigen",
  "account_edit.profile_tab.show_media_replies.description": "Durch das Aktivieren werden sowohl deine Beiträge als auch deine Antworten auf Beiträge anderer im „Medien“-Tab angezeigt.",
  "account_edit.profile_tab.show_media_replies.title": "Antworten im „Medien“-Tab anzeigen",
  "account_edit.profile_tab.show_relations.description": "Dadurch werden die Konten, die dir folgen, und die Profile, denen du folgst, für andere sichtbar. Sie werden immer sehen können, ob du ihnen folgst.",
  "account_edit.profile_tab.show_relations.title": "Follower und „Folge ich“ anzeigen",
  "account_edit.profile_tab.subtitle": "Passe die Darstellung deines Profils an.",
  "account_edit.profile_tab.title": "Einstellungen für die Profilübersicht",
  "account_edit.save": "Speichern",
  "account_edit.upload_modal.back": "Zurück",
  "account_edit.upload_modal.done": "Fertig",
  "account_edit.upload_modal.next": "Weiter",
  "account_edit.upload_modal.step_crop.zoom": "Vergrößern",
  "account_edit.upload_modal.step_upload.button": "Datei hochladen",
  "account_edit.upload_modal.step_upload.dragging": "Zum Hochladen hier ablegen",
  "account_edit.upload_modal.step_upload.header": "Wähle ein Bild",
  "account_edit.upload_modal.step_upload.hint": "WebP, PNG, GIF oder JPG. Höchstens {limit} MB groß.{br}Das Bild wird auf {width}x{height} px skaliert.",
  "account_edit.upload_modal.title_add.avatar": "Profilbild hinzufügen",
  "account_edit.upload_modal.title_add.header": "Titelbild hinzufügen",
  "account_edit.upload_modal.title_replace.avatar": "Profilbild ersetzen",
  "account_edit.upload_modal.title_replace.header": "Titelbild ersetzen",
  "account_edit.verified_modal.details": "Beweise die Echtheit deines Mastodon-Profils, indem du verifizierte Links zu deinen persönlichen Websites ergänzt. So funktioniert’s:",
  "account_edit.verified_modal.invisible_link.details": "Füge den Link in den Header ein. Der wichtige Teil ist rel=\"me\". Du kannst auch den Tag link im Header (statt {tag}) verwenden, jedoch muss die Internetseite ohne JavaScript abrufbar sein.",
  "account_edit.verified_modal.invisible_link.summary": "Wie blende ich den Link aus?",
  "account_edit.verified_modal.step1.header": "Kopiere den unten stehenden HTML-Code und füge ihn in den Header deiner Website ein",
  "account_edit.verified_modal.step2.details": "Wenn du deine Website bereits in ein Zusatzfeld eingetragen hast, musst du es noch einmal löschen und sie neu hinzufügen, damit die Verifizierung startet.",
  "account_edit.verified_modal.step2.header": "Ergänze deine Website in ein Zusatzfeld",
  "account_edit.verified_modal.title": "So erstellst du einen verifizierten Link",
  "account_edit_tags.add_tag": "#{tagName} hinzufügen",
  "account_edit_tags.column_title": "Hashtags bearbeiten",
  "account_edit_tags.help_text": "Vorgestellte Hashtags können dabei helfen, dein Profil zu entdecken und besser mit dir zu interagieren. Sie dienen als Filter in der Aktivitätenübersicht deines Profils.",
  "account_edit_tags.max_tags_reached": "Du hast die maximale Anzahl an vorgestellten Hashtags erreicht.",
  "account_edit_tags.search_placeholder": "Gib einen Hashtag ein …",
  "account_edit_tags.suggestions": "Vorschläge:",
  "account_edit_tags.tag_status_count": "{count, plural, one {# Beitrag} other {# Beiträge}}",
  "account_list.hidden_notice": "Die Liste ist nur für dich sichtbar. Damit sie für andere zugänglich wird, rufe <link>{page} > {modal}> {field}</link> auf.",
  "account_list.total": "{total, plural, one {# Konto} other {# Konten}}",
  "admin.dashboard.daily_retention": "Verweildauer der Nutzer*innen pro Tag seit der Registrierung",
  "admin.dashboard.monthly_retention": "Verweildauer der Nutzer*innen pro Monat seit der Registrierung",
  "admin.dashboard.retention.average": "Durchschnitt",
  "admin.dashboard.retention.cohort": "Monat der Registrierung",
  "admin.dashboard.retention.cohort_size": "Neue Konten",
  "admin.impact_report.instance_accounts": "Konten, die dadurch gelöscht würden",
  "admin.impact_report.instance_followers": "Follower, die unsere Nutzer*innen verlieren würden",
  "admin.impact_report.instance_follows": "Follower, die deren Nutzer*innen verlieren würden",
  "admin.impact_report.title": "Zusammenfassung der Auswirkung",
  "alert.need_reload.message": "Mastodon wurde aktualisiert. Möglicherweise funktioniert nicht alles ordnungsgemäß, bis die Seite neu geladen wurde.",
  "alert.rate_limited.message": "Bitte versuche es um {retry_time, time, medium} erneut.",
  "alert.rate_limited.title": "Anfragelimit überschritten",
  "alert.unexpected.message": "Ein unerwarteter Fehler ist aufgetreten.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Bildbeschreibung",
  "alt_text_modal.add_alt_text": "Bildbeschreibung hinzufügen",
  "alt_text_modal.add_text_from_image": "Text aus Bild hinzufügen",
  "alt_text_modal.cancel": "Abbrechen",
  "alt_text_modal.change_thumbnail": "Vorschaubild ändern",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Beschreibe den Inhalt für Menschen, die taub oder hörbehindert sind …",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Beschreibe den Inhalt für Menschen, die blind oder sehbehindert sind …",
  "alt_text_modal.done": "Fertig",
  "announcement.announcement": "Ankündigung",
  "annual_report.announcement.action_build": "Erstelle mein Wrapstodon",
  "annual_report.announcement.action_dismiss": "Nein danke",
  "annual_report.announcement.action_view": "Mein Wrapstodon anschauen",
  "annual_report.announcement.description": "Erfahre mehr über deine Aktivitäten auf Mastodon im vergangenen Jahr.",
  "annual_report.announcement.title": "Wrapstodon {year} ist fertiggestellt",
  "annual_report.nav_item.badge": "Neu",
  "annual_report.shared_page.donate": "Spenden",
  "annual_report.shared_page.footer": "Mit {heart} vom Mastodon-Team erstellt",
  "annual_report.shared_page.footer_server_info": "{username} verwendet {domain} – eine von vielen Gemeinschaften, die durch Mastodon ermöglicht werden.",
  "annual_report.summary.archetype.booster.desc_public": "{name} hielt Ausschau nach Beiträgen, um sie zu teilen und den Autor*innen mehr Reichweite zu bescheren.",
  "annual_report.summary.archetype.booster.desc_self": "Du hieltest Ausschau nach Beiträgen, um sie zu teilen und den Autor*innen mehr Reichweite zu bescheren.",
  "annual_report.summary.archetype.booster.name": "Flitzebogen",
  "annual_report.summary.archetype.die_drei_fragezeichen": "???",
  "annual_report.summary.archetype.lurker.desc_public": "{name} befand sich irgendwo in den Tiefen von Mastodon und genoss das stille Dasein.",
  "annual_report.summary.archetype.lurker.desc_self": "Du befandest dich irgendwo in den Tiefen von Mastodon und genossest das stille Dasein.",
  "annual_report.summary.archetype.lurker.name": "Unerschütterliche*r",
  "annual_report.summary.archetype.oracle.desc_public": "{name} verfasste mehr Beiträge als Antworten, damit Mastodon abwechslungsreich blieb.",
  "annual_report.summary.archetype.oracle.desc_self": "Du verfasstest mehr Beiträge als Antworten, damit Mastodon abwechslungsreich blieb.",
  "annual_report.summary.archetype.oracle.name": "Orakel",
  "annual_report.summary.archetype.pollster.desc_public": "{name} erstellte mehr Umfragen als alles andere und förderte die Neugier auf Mastodon.",
  "annual_report.summary.archetype.pollster.desc_self": "Du erstelltest mehr Umfragen als alles andere und fördertest die Neugier auf Mastodon.",
  "annual_report.summary.archetype.pollster.name": "Grübler*in",
  "annual_report.summary.archetype.replier.desc_public": "{name} antwortete regelmäßig auf die Beiträge anderer und sorgte für blühende Diskussionen auf Mastodon.",
  "annual_report.summary.archetype.replier.desc_self": "Du antwortetest regelmäßig auf die Beiträge anderer und sorgtest für blühende Diskussionen auf Mastodon.",
  "annual_report.summary.archetype.replier.name": "Schmetterling",
  "annual_report.summary.archetype.reveal": "Enthülle mein Wesen",
  "annual_report.summary.archetype.reveal_description": "Danke, dass du Teil von Mastodon bist! Zeit herauszufinden, welches Wesen du {year} verkörpert hast.",
  "annual_report.summary.archetype.title_public": "Wesen von {name}",
  "annual_report.summary.archetype.title_self": "Mein Wesen",
  "annual_report.summary.close": "Schließen",
  "annual_report.summary.copy_link": "Link kopieren",
  "annual_report.summary.followers.new_followers": "{count, plural, one {neuer Follower} other {neue Follower}}",
  "annual_report.summary.highlighted_post.boost_count": "Dieser Beitrag wurde {count, plural, one {1 ×} other {# ×}} geteilt.",
  "annual_report.summary.highlighted_post.favourite_count": "Dieser Beitrag wurde {count, plural, one {1 ×} other {# ×}} favorisiert.",
  "annual_report.summary.highlighted_post.reply_count": "Dieser Beitrag erhielt {count, plural, one {1 Antwort} other {# Antworten}}.",
  "annual_report.summary.highlighted_post.title": "Beliebtester Beitrag",
  "annual_report.summary.most_used_app.most_used_app": "am häufigsten verwendete App",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "am häufigsten verwendeter Hashtag",
  "annual_report.summary.most_used_hashtag.used_count": "Du verwendetest diesen Hashtag in {count, plural, one {1 Beitrag} other {# Beiträgen}}.",
  "annual_report.summary.most_used_hashtag.used_count_public": "{name} verwendete diesen Hashtag in {count, plural, one {1 Beitrag} other {# Beiträgen}}.",
  "annual_report.summary.new_posts.new_posts": "neue Beiträge",
  "annual_report.summary.percentile.text": "<topLabel>Damit gehörst du zu den obersten</topLabel><percentage></percentage><bottomLabel>der Nutzer*innen auf {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Wir werden Bernie nichts verraten.",
  "annual_report.summary.share_elsewhere": "Woanders teilen",
  "annual_report.summary.share_message": "Ich bin vom Wesen {archetype}!",
  "annual_report.summary.share_on_mastodon": "Auf Mastodon teilen",
  "attachments_list.unprocessed": "(ausstehend)",
  "audio.hide": "Audio ausblenden",
  "block_modal.no_collections": "Ihr werdet euch gegenseitig nicht zu Sammlungen hinzufügen können. Du wirst, falls zutreffend, aus deren Sammlungen entfernt werden.",
  "block_modal.remote_users_caveat": "Wir werden den Server {domain} bitten, deine Entscheidung zu respektieren. Allerdings kann nicht garantiert werden, dass sie eingehalten wird, weil einige Server Blockierungen unterschiedlich handhaben können. Öffentliche Beiträge können für nicht angemeldete Nutzer*innen weiterhin sichtbar sein.",
  "block_modal.show_less": "Weniger anzeigen",
  "block_modal.show_more": "Mehr anzeigen",
  "block_modal.they_cant_mention": "Ihr werdet euch gegenseitig nicht erwähnen, folgen oder zitieren können.",
  "block_modal.they_cant_see_posts": "Deine Beiträge können nicht mehr angesehen werden und du wirst deren Beiträge nicht mehr sehen.",
  "block_modal.they_will_know": "Das Profil wird erkennen können, dass du es blockiert hast.",
  "block_modal.title": "Profil blockieren?",
  "block_modal.you_wont_see_mentions": "Du wirst keine Beiträge sehen, die dieses Profil erwähnen.",
  "boost_modal.combo": "Mit {combo} erscheint dieses Fenster nicht mehr",
  "boost_modal.reblog": "Beitrag teilen?",
  "boost_modal.undo_reblog": "Beitrag nicht mehr teilen?",
  "bundle_column_error.copy_stacktrace": "Fehlerbericht kopieren",
  "bundle_column_error.error.body": "Die angeforderte Seite konnte nicht dargestellt werden. Dies könnte auf einen Fehler in unserem Code oder auf ein Browser-Kompatibilitätsproblem zurückzuführen sein.",
  "bundle_column_error.error.title": "Oh nein!",
  "bundle_column_error.network.body": "Beim Laden dieser Seite ist ein Fehler aufgetreten. Die Ursache könnte ein vorübergehendes Problem mit deiner Internetverbindung oder diesem Server sein.",
  "bundle_column_error.network.title": "Netzwerkfehler",
  "bundle_column_error.retry": "Erneut versuchen",
  "bundle_column_error.return": "Zurück zur Startseite",
  "bundle_column_error.routing.body": "Die angeforderte Seite konnte nicht gefunden werden. Bist du dir sicher, dass die URL in der Adressleiste korrekt ist?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Schließen",
  "bundle_modal_error.message": "Beim Laden des Inhalts ist etwas schiefgelaufen.",
  "bundle_modal_error.retry": "Erneut versuchen",
  "callout.dismiss": "Verwerfen",
  "carousel.current": "<sr>Seite</sr> {current, number}/{max, number}",
  "carousel.slide": "Seite {current, number} von {max, number}",
  "character_counter.recommended": "{currentLength}/{maxLength} empfohlenen Zeichen",
  "character_counter.required": "{currentLength}/{maxLength} Zeichen",
  "closed_registrations.other_server_instructions": "Da Mastodon dezentralisiert ist, kannst du dich auch woanders im Fediverse registrieren und trotzdem mit diesem Server in Kontakt bleiben.",
  "closed_registrations_modal.description": "Das Anlegen eines Kontos auf {domain} ist derzeit nicht möglich, aber bedenke, dass du nicht zwingend auf {domain} ein Konto benötigst, um Mastodon nutzen zu können.",
  "closed_registrations_modal.find_another_server": "Anderen Server suchen",
  "closed_registrations_modal.preamble": "Mastodon ist dezentralisiert, das heißt, unabhängig davon, wo du dein Konto erstellst, kannst du jedem Profil auf diesem Server folgen und mit ihm interagieren. Du kannst sogar deinen eigenen Mastodon-Server hosten!",
  "closed_registrations_modal.title": "Bei Mastodon registrieren",
  "collection.share_modal.share_link_label": "Link teilen",
  "collection.share_modal.share_via_post": "Auf Mastodon veröffentlichen",
  "collection.share_modal.share_via_system": "Teilen …",
  "collection.share_modal.title": "Sammlung teilen",
  "collection.share_modal.title_new": "Teile deine neue Sammlung!",
  "collection.share_template_other": "Seht euch diese coole Sammlung an:",
  "collection.share_template_own": "Seht euch meine neue Sammlung an:",
  "collections.account_count": "{count, plural, one {# Konto} other {# Konten}}",
  "collections.accounts.empty_description": "Füge bis zu {count} Konten hinzu",
  "collections.accounts.empty_editor_title": "Noch befindet sich niemand in dieser Sammlung",
  "collections.accounts.empty_title": "Diese Sammlung ist leer",
  "collections.add_to_collection": "{name} einer Sammlung hinzufügen",
  "collections.block_collection_owner": "Konto blockieren",
  "collections.by_account": "von {account_handle}",
  "collections.collection_description": "Beschreibung",
  "collections.collection_language": "Sprache",
  "collections.collection_language_none": "Nicht festgelegt",
  "collections.collection_name": "Titel",
  "collections.collection_topic": "Thema",
  "collections.confirm_account_removal": "Möchtest du dieses Konto wirklich aus der Sammlung entfernen?",
  "collections.content_warning": "Inhaltswarnung",
  "collections.continue": "Fortfahren",
  "collections.copy_link": "Link kopieren",
  "collections.copy_link_confirmation": "Link zur Sammlung in die Zwischenablage kopiert",
  "collections.create.accounts_title": "Wen möchtest du in dieser Sammlung präsentieren?",
  "collections.create.basic_details_title": "Allgemeine Informationen",
  "collections.create.steps": "Schritt {step}/{total}",
  "collections.create_collection": "Sammlung erstellen",
  "collections.create_new_collection": "Neue Sammlung erstellen",
  "collections.delete_collection": "Sammlung löschen",
  "collections.description_length_hint": "Maximal 100 Zeichen",
  "collections.detail.author_added_you_on_date": "{author} fügte dich am {date} hinzu",
  "collections.detail.loading": "Sammlung wird geladen …",
  "collections.detail.revoke_inclusion": "Mich entfernen",
  "collections.detail.sensitive_content": "Inhaltswarnung",
  "collections.detail.sensitive_note": "Die Beschreibung und Konten sind möglicherweise nicht für alle geeignet.",
  "collections.detail.share": "Sammlung teilen",
  "collections.detail.you_are_in_this_collection": "Du bist ein Teil dieser Sammlung",
  "collections.edit_details": "Details bearbeiten",
  "collections.error_loading_collections": "Beim Laden dieser Sammlungen ist ein Fehler aufgetreten.",
  "collections.hidden_accounts_description": "Du hast {count, plural, one {dieses Profil} other {diese Profile}} blockiert oder stummgeschaltet",
  "collections.hidden_accounts_link": "{count, plural, one {# Konto ausgeblendet} other {# Konten ausgeblendet}}",
  "collections.hints.accounts_counter": "{count}/{max} Konten",
  "collections.last_updated_at": "Aktualisiert: {date}",
  "collections.list.collections_with_count": "{count, plural, one {# Sammlung} other {# Sammlungen}}",
  "collections.list.created_by_author": "Von {name} erstellt",
  "collections.list.created_by_you": "Von mir erstellt",
  "collections.list.featuring_you": "Stellen mich vor",
  "collections.manage_accounts": "Profile verwalten",
  "collections.mark_as_sensitive": "Mit Inhaltswarnung versehen",
  "collections.mark_as_sensitive_hint": "Die Beschreibung sowie enthaltenen Profile werden durch eine Inhaltswarnung ausgeblendet. Der Titel bleibt weiterhin sichtbar.",
  "collections.maximum_collection_count_description": "Auf deinem Server darfst du bis zu {count} Sammlungen erstellen.",
  "collections.maximum_collection_count_reached": "Du hast die Höchstzahl an Sammlungen erreicht",
  "collections.name_length_hint": "Maximal 40 Zeichen",
  "collections.new_collection": "Neue Sammlung",
  "collections.pending_accounts.message": "Ein Konto erscheint als ausstehend, wenn eine Antwort vom Konto oder deren Server erwartet wird. Ausstehende Konten sind nur für dich sichtbar.",
  "collections.pending_accounts.title": "Warum sehe ich ausstehende Konten?",
  "collections.remove_account": "Entfernen",
  "collections.report_collection": "Sammlung melden",
  "collections.revoke_collection_inclusion": "Mich aus dieser Sammlung entfernen",
  "collections.revoke_inclusion.confirmation": "Du wurdest aus „{collection}“ entfernt",
  "collections.revoke_inclusion.error": "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
  "collections.search_accounts_label": "Suche nach einem Konto, um es hinzuzufügen",
  "collections.search_accounts_max_reached": "Du hast die Höchstzahl an Konten hinzugefügt",
  "collections.sensitive": "Inhaltswarnung",
  "collections.share_short": "Teilen",
  "collections.sort_alphabetical": "Alphabetisch",
  "collections.sort_by": "Sortieren nach:",
  "collections.sort_date_added": "Hinzugefügt",
  "collections.sort_last_active": "Neueste Aktivität",
  "collections.sort_most_followers": "Followerzahl",
  "collections.suggestions.can_not_add": "Kann nicht hinzugefügt werden",
  "collections.suggestions.can_not_add_desc": "Diese Konten möchten möglicherweise nicht entdeckt werden oder deren Server unterstützt noch keine Sammlungen.",
  "collections.suggestions.must_follow": "Profil muss gefolgt werden",
  "collections.suggestions.must_follow_desc": "Diese Konten überprüfen ihre Follower-Anfragen manuell. Follower können sie zu Sammlungen hinzufügen.",
  "collections.topic_hint": "Ein Hashtag für diese Sammlung kann anderen dabei helfen, dein Anliegen besser einordnen zu können.",
  "collections.topic_special_chars_hint": "Sonderzeichen werden beim Speichern entfernt",
  "collections.unlisted_collections_description": "Die Sammlungen sind für andere nicht auf deinem Profil sichtbar. Ein direkter Zugriff ist per Link möglich.",
  "collections.unlisted_collections_with_count": "Nicht öffentliche Sammlungen ({count})",
  "collections.view_collection": "Sammlungen anzeigen",
  "collections.visibility_public": "Öffentlich",
  "collections.visibility_public_hint": "Wird in den Suchergebnissen und anderen Bereichen mit Empfehlungen angezeigt.",
  "collections.visibility_title": "Sichtbarkeit",
  "collections.visibility_unlisted": "Nicht gelistet",
  "collections.visibility_unlisted_hint": "Für alle mit einem Link sichtbar. Wird vor Suchergebnissen und Empfehlungen verborgen.",
  "column.about": "Über",
  "column.blocks": "Blockierte Profile",
  "column.bookmarks": "Lesezeichen",
  "column.community": "Lokale Timeline",
  "column.create_list": "Liste erstellen",
  "column.direct": "Private Erwähnungen",
  "column.directory": "Profile durchstöbern",
  "column.domain_blocks": "Blockierte Domains",
  "column.edit_list": "Liste bearbeiten",
  "column.favourites": "Favoriten",
  "column.firehose": "Live-Feeds",
  "column.firehose_local": "Live-Feed dieses Servers",
  "column.firehose_singular": "Live-Feed",
  "column.follow_requests": "Follower-Anfragen",
  "column.home": "Startseite",
  "column.list_members": "Listenmitglieder verwalten",
  "column.lists": "Listen",
  "column.mutes": "Stummgeschaltete Profile",
  "column.notifications": "Benachrichtigungen",
  "column.other_collections": "Sammlungen von {name}",
  "column.pins": "Angeheftete Beiträge",
  "column.public": "Föderierte Timeline",
  "column.your_collections": "Deine Sammlungen",
  "column_back_button.label": "Zurück",
  "column_header.hide_settings": "Einstellungen ausblenden",
  "column_header.moveLeft_settings": "Diese Spalte nach links verschieben",
  "column_header.moveRight_settings": "Diese Spalte nach rechts verschieben",
  "column_header.pin": "Anheften",
  "column_header.show_settings": "Einstellungen anzeigen",
  "column_header.unpin": "Lösen",
  "column_search.cancel": "Abbrechen",
  "combobox.close_results": "Ergebnisse schließen",
  "combobox.loading": "Lädt",
  "combobox.no_results_found": "Keine Ergebnisse für diese Suche",
  "combobox.open_results": "Ergebnisse öffnen",
  "combobox.results_available": "{count, plural, one {# Vorschlag} other {# Vorschläge}} vorhanden. Die Auswahl kann mit der Pfeiltaste hoch oder runter geändert und mit der Eingabetaste bestätigt werden.",
  "community.column_settings.local_only": "Nur lokal",
  "community.column_settings.media_only": "Nur Beiträge mit Medien",
  "community.column_settings.remote_only": "Nur andere Server im Fediverse",
  "compose.error.blank_post": "Beitrag muss einen Inhalt haben.",
  "compose.language.change": "Sprache festlegen",
  "compose.language.search": "Sprachen suchen …",
  "compose.published.body": "Beitrag veröffentlicht.",
  "compose.published.open": "Öffnen",
  "compose.saved.body": "Beitrag gespeichert.",
  "compose_form.direct_message_warning_learn_more": "Mehr erfahren",
  "compose_form.encryption_warning": "Beiträge auf Mastodon sind nicht Ende-zu-Ende-verschlüsselt. Teile keine sensiblen Informationen über Mastodon, auch nicht als „private Erwähnung“.",
  "compose_form.hashtag_warning": "Dieser Beitrag wird unter keinem Hashtag sichtbar sein, weil er nicht öffentlich ist. Nur öffentliche Beiträge können nach Hashtags durchsucht werden.",
  "compose_form.lock_disclaimer": "Dein Profil ist nicht {locked}. Andere können dir folgen und deine Beiträge sehen, die nur für Follower bestimmt sind.",
  "compose_form.lock_disclaimer.lock": "geschützt",
  "compose_form.placeholder": "Was gibts Neues?",
  "compose_form.poll.duration": "Laufzeit",
  "compose_form.poll.multiple": "Mehrfachauswahl",
  "compose_form.poll.option_placeholder": "{number}. Auswahl",
  "compose_form.poll.single": "Einfachauswahl",
  "compose_form.poll.switch_to_multiple": "Mehrfachauswahl erlauben",
  "compose_form.poll.switch_to_single": "Nur Einfachauswahl erlauben",
  "compose_form.poll.type": "Typ",
  "compose_form.publish": "Veröffentlichen",
  "compose_form.reply": "Antworten",
  "compose_form.save_changes": "Aktualisieren",
  "compose_form.spoiler.marked": "Inhaltswarnung entfernen",
  "compose_form.spoiler.unmarked": "Inhaltswarnung hinzufügen",
  "compose_form.spoiler_placeholder": "Inhaltswarnung (optional)",
  "confirmation_modal.cancel": "Abbrechen",
  "confirmations.block.confirm": "Blockieren",
  "confirmations.delete.confirm": "Löschen",
  "confirmations.delete.message": "Möchtest du diesen Beitrag wirklich löschen?",
  "confirmations.delete.title": "Beitrag löschen?",
  "confirmations.delete_collection.confirm": "Löschen",
  "confirmations.delete_collection.message": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "confirmations.delete_collection.title": "„{name}“ löschen?",
  "confirmations.delete_list.confirm": "Löschen",
  "confirmations.delete_list.message": "Bist du dir sicher, dass du diese Liste endgültig löschen möchtest?",
  "confirmations.delete_list.title": "Liste löschen?",
  "confirmations.discard_draft.confirm": "Verwerfen und fortfahren",
  "confirmations.discard_draft.edit.cancel": "Bearbeitung fortsetzen",
  "confirmations.discard_draft.edit.message": "Beim Fortfahren werden alle am Beitrag vorgenommenen Änderungen verworfen.",
  "confirmations.discard_draft.edit.title": "Änderungen an diesem Beitrag verwerfen?",
  "confirmations.discard_draft.post.cancel": "Entwurf fortsetzen",
  "confirmations.discard_draft.post.message": "Beim Fortfahren wird der gerade verfasste Beitrag verworfen.",
  "confirmations.discard_draft.post.title": "Entwurf verwerfen?",
  "confirmations.discard_edit_media.confirm": "Verwerfen",
  "confirmations.discard_edit_media.message": "Du hast Änderungen an der Medienbeschreibung oder -vorschau vorgenommen, die noch nicht gespeichert sind. Trotzdem verwerfen?",
  "confirmations.follow_to_list.confirm": "Folgen und zur Liste hinzufügen",
  "confirmations.follow_to_list.message": "Du musst {name} folgen, um das Profil zu einer Liste hinzufügen zu können.",
  "confirmations.follow_to_list.title": "Profil folgen?",
  "confirmations.hide_featured_tab.confirm": "Tab ausblenden",
  "confirmations.hide_featured_tab.intro": "Du kannst die Einstellungen jederzeit unter <i>Profil bearbeiten > Profil-Tab-Einstellungen</i> ändern.",
  "confirmations.hide_featured_tab.message": "Dieser Tab wird auf {serverName} und auf anderen Servern ab Mastodon v4.6 nicht angezeigt. Anderswo kann die Darstellung abweichen.",
  "confirmations.hide_featured_tab.title": "„Vorgestellt“-Tab ausblenden?",
  "confirmations.logout.confirm": "Abmelden",
  "confirmations.logout.message": "Möchtest du dich wirklich ausloggen?",
  "confirmations.logout.title": "Abmelden?",
  "confirmations.missing_alt_text.confirm": "Bildbeschreibung hinzufügen",
  "confirmations.missing_alt_text.message": "Dein Beitrag enthält Medien ohne Bildbeschreibung. Mit ALT-Texten erreichst Du auch Menschen, die blind oder sehbehindert sind.",
  "confirmations.missing_alt_text.secondary": "Trotzdem veröffentlichen",
  "confirmations.missing_alt_text.title": "Bildbeschreibung hinzufügen?",
  "confirmations.mute.confirm": "Stummschalten",
  "confirmations.private_quote_notify.cancel": "Zurück zur Bearbeitung",
  "confirmations.private_quote_notify.confirm": "Beitrag veröffentlichen",
  "confirmations.private_quote_notify.do_not_show_again": "Diesen Hinweis nicht mehr anzeigen",
  "confirmations.private_quote_notify.message": "Dein Beitrag wird von dem zitierten sowie den erwähnten Profilen gesehen werden können, auch wenn sie dir nicht folgen.",
  "confirmations.private_quote_notify.title": "Mit Followern und erwähnten Profilen teilen?",
  "confirmations.quiet_post_quote_info.dismiss": "Nicht erneut erinnern",
  "confirmations.quiet_post_quote_info.got_it": "Verstanden",
  "confirmations.quiet_post_quote_info.message": "Beim Zitieren eines Beitrags, dessen Sichtbarkeit „Öffentlich (still)“ ist, wird auch dein Beitrag, der das Zitat enthält, aus den Trends und öffentlichen Timelines ausgeblendet.",
  "confirmations.quiet_post_quote_info.title": "Zitieren eines Beitrags mit der Sichtbarkeit „Öffentlich (still)“",
  "confirmations.redraft.confirm": "Löschen und neu erstellen",
  "confirmations.redraft.message": "Möchtest du diesen Beitrag wirklich löschen und neu verfassen? Alle Favoriten sowie die bisher geteilten Beiträge werden verloren gehen und Antworten auf den ursprünglichen Beitrag verlieren den Zusammenhang.",
  "confirmations.redraft.title": "Beitrag löschen & neu verfassen?",
  "confirmations.remove_from_followers.confirm": "Follower entfernen",
  "confirmations.remove_from_followers.message": "{name} wird dir nicht länger folgen. Bist du dir sicher?",
  "confirmations.remove_from_followers.title": "Follower entfernen?",
  "confirmations.revoke_collection_inclusion.confirm": "Mich entfernen",
  "confirmations.revoke_collection_inclusion.message": "Du wirst in den nächsten 24 Stunden nicht noch einmal zu dieser Sammlung hinzugefügt werden können. Falls du nie wieder von diesem Profil zu einer Sammlung hinzugefügt werden möchtest, kannst du es blockieren.",
  "confirmations.revoke_collection_inclusion.title": "Möchtest du wirklich aus dieser Sammlung entfernt werden?",
  "confirmations.revoke_quote.confirm": "Zitat entfernen",
  "confirmations.revoke_quote.message": "Diese Aktion kann nicht rückgängig gemacht werden.",
  "confirmations.revoke_quote.title": "Mein Zitat aus diesem Beitrag entfernen?",
  "confirmations.unblock.confirm": "Blockierung aufheben",
  "confirmations.unblock.title": "Blockierung von {name} aufheben?",
  "confirmations.unfollow.confirm": "Entfolgen",
  "confirmations.unfollow.title": "{name} entfolgen?",
  "confirmations.withdraw_request.confirm": "Anfrage zurückziehen",
  "confirmations.withdraw_request.title": "Anfrage zum Folgen von {name} widerrufen?",
  "content_warning.hide": "Beitrag ausblenden",
  "content_warning.show": "Trotzdem anzeigen",
  "content_warning.show_more": "Beitrag anzeigen",
  "content_warning.show_short": "Anzeigen",
  "conversation.delete": "Unterhaltung löschen",
  "conversation.mark_as_read": "Als gelesen markieren",
  "conversation.open": "Unterhaltung anzeigen",
  "conversation.with": "Mit {names}",
  "copy_icon_button.copied": "In die Zwischenablage kopiert",
  "copy_icon_button.copy_this_text": "Link in die Zwischenablage kopieren",
  "copypaste.copied": "Kopiert",
  "copypaste.copy_to_clipboard": "In die Zwischenablage kopieren",
  "custom_homepage.about": "Über",
  "custom_homepage.about_this_server": "Über diesen Server",
  "custom_homepage.administered_by": "Administriert von",
  "custom_homepage.contact": "Kontakt:",
  "custom_homepage.latest_activity": "Neueste Aktivität",
  "custom_homepage.these_are_the_latest_posts": "Diese sind die 40 neuesten Beiträge von Konten dieses Servers.",
  "directory.federated": "Aus bekanntem Fediverse",
  "directory.local": "Nur von dieser Domain {domain}",
  "directory.new_arrivals": "Neue Profile",
  "directory.recently_active": "Kürzlich aktiv",
  "disabled_account_banner.account_settings": "Kontoeinstellungen",
  "disabled_account_banner.text": "Dein Konto {disabledAccount} ist derzeit deaktiviert.",
  "dismissable_banner.community_timeline": "Das sind die neuesten öffentlichen Beiträge von Profilen, deren Konten von {domain} verwaltet werden.",
  "dismissable_banner.dismiss": "Ablehnen",
  "dismissable_banner.public_timeline": "Das sind die neuesten öffentlichen Beiträge von Profilen im Fediverse, denen Leute auf {domain} folgen.",
  "domain_block_modal.block": "Server blockieren",
  "domain_block_modal.block_account_instead": "Stattdessen @{name} blockieren",
  "domain_block_modal.they_can_interact_with_old_posts": "Profile von diesem Server werden mit deinen älteren Beiträgen interagieren können.",
  "domain_block_modal.they_cant_follow": "Niemand von diesem Server wird dir folgen können.",
  "domain_block_modal.they_wont_know": "Es wird nicht erkennbar sein, dass diese Domain blockiert wurde.",
  "domain_block_modal.title": "Domain blockieren?",
  "domain_block_modal.you_will_lose_num_followers": "Du wirst {followersCount, plural, one {{followersCountDisplay} Follower} other {{followersCountDisplay} Follower}} verlieren und {followingCount, plural, one {{followingCountDisplay} Profil} other {{followingCountDisplay} Profilen}} entfolgen.",
  "domain_block_modal.you_will_lose_relationships": "Du wirst von diesem Server alle Follower und Profile, denen du dort folgst, verlieren.",
  "domain_block_modal.you_wont_see_posts": "Du wirst keine Beiträge oder Benachrichtigungen von Profilen auf diesem Server sehen.",
  "dropdown.empty": "Option auswählen",
  "email_subscriptions.email": "E-Mail-Adresse",
  "email_subscriptions.form.action": "Abonnieren",
  "email_subscriptions.form.bottom": "Lass dir Beiträge per E-Mail zuschicken, ohne ein Mastodon-Konto zu erstellen. Du kannst die E-Mail-Abonnements jederzeit abbestellen. Weitere Details findest du in der <a>Datenschutzerklärung</a>.",
  "email_subscriptions.form.title": "Erhalte eine E-Mail bei Neuigkeiten von {name}",
  "email_subscriptions.submitted.lead": "Überprüfe dein Postfach, um die Benachrichtigungen per E-Mail zu aktivieren.",
  "email_subscriptions.submitted.title": "Ein weiterer Schritt",
  "email_subscriptions.validation.email.blocked": "Gesperrter E-Mail-Provider",
  "email_subscriptions.validation.email.invalid": "Ungültige E-Mail-Adresse",
  "embed.instructions": "Du kannst diesen Beitrag außerhalb des Fediverse (z. B. in deine Website) einbetten, indem du diesen Code kopierst und dort einfügst.",
  "embed.preview": "Vorschau:",
  "emoji_button.activity": "Aktivitäten",
  "emoji_button.clear": "Leeren",
  "emoji_button.custom": "Spezielle Emojis dieses Servers",
  "emoji_button.flags": "Flaggen",
  "emoji_button.food": "Essen & Trinken",
  "emoji_button.label": "Emoji hinzufügen",
  "emoji_button.nature": "Natur",
  "emoji_button.not_found": "Keine passenden Emojis gefunden",
  "emoji_button.objects": "Gegenstände",
  "emoji_button.people": "Personen",
  "emoji_button.recent": "Häufig verwendet",
  "emoji_button.search": "Suchen …",
  "emoji_button.search_results": "Suchergebnisse",
  "emoji_button.symbols": "Symbole",
  "emoji_button.travel": "Reisen & Orte",
  "empty_column.account_featured.other": "{acct} hat noch nichts vorgestellt.",
  "empty_column.account_featured_self.no_collections_button": "Sammlung erstellen",
  "empty_column.account_featured_self.no_collections_hide_tab": "Diesen Tab ausblenden",
  "empty_column.account_featured_self.showcase_accounts": "Präsentiere deine liebsten Konten",
  "empty_column.account_featured_self.showcase_accounts_desc": "Sammlungen sind kuratierte Listen, die anderen helfen, mehr Konten im Fediverse zu entdecken.",
  "empty_column.account_featured_unknown.other": "Dieser Account hat noch nichts vorgestellt.",
  "empty_column.account_hides_collections": "Das Profil hat sich entschieden, diese Information nicht zu veröffentlichen",
  "empty_column.account_suspended": "Konto dauerhaft gesperrt",
  "empty_column.account_timeline": "Keine Beiträge vorhanden!",
  "empty_column.account_unavailable": "Profil nicht verfügbar",
  "empty_column.blocks": "Du hast bisher keine Profile blockiert.",
  "empty_column.bookmarked_statuses": "Du hast bisher keine Beiträge als Lesezeichen abgelegt. Sobald du einen Beitrag als Lesezeichen speicherst, wird er hier erscheinen.",
  "empty_column.collections": "{acct} hat noch keine Sammlungen erstellt.",
  "empty_column.collections.featured_in": "Du wurdest noch keiner Sammlung hinzugefügt.",
  "empty_column.collections.featured_in_undiscoverable": "Damit du zu Sammlungen hinzugefügt werden kannst, muss „Mich beim Entdecken berücksichtigen“ unter <link>Einstellungen > Datenschutz und Reichweite</link> aktiviert werden",
  "empty_column.collections_self": "Du hast noch keine Sammlungen erstellt.",
  "empty_column.community": "Die lokale Timeline ist leer. Schreibe einen öffentlichen Beitrag, um den Stein ins Rollen zu bringen!",
  "empty_column.direct": "Du hast noch keine privaten Erwähnungen. Sobald du eine sendest oder erhältst, wird sie hier erscheinen.",
  "empty_column.disabled_feed": "Diesen Feed haben deine Server-Administrator*innen deaktiviert.",
  "empty_column.domain_blocks": "Du hast bisher keine Domains blockiert.",
  "empty_column.explore_statuses": "Momentan trendet nichts. Schau später wieder vorbei!",
  "empty_column.favourited_statuses": "Du hast noch keine Beiträge favorisiert. Sobald du einen favorisierst, wird er hier erscheinen.",
  "empty_column.favourites": "Diesen Beitrag hat bisher noch niemand favorisiert. Sobald es jemand tut, wird das Profil hier erscheinen.",
  "empty_column.follow_requests": "Es liegen derzeit keine Follower-Anfragen vor. Sobald du eine erhältst, wird sie hier erscheinen.",
  "empty_column.followed_tags": "Du folgst noch keinen Hashtags. Sobald du Hashtags abonniert hast, werden sie hier angezeigt.",
  "empty_column.hashtag": "Unter diesem Hashtag gibt es noch nichts.",
  "empty_column.home": "Die Timeline deiner Startseite ist leer! Folge mehr Leuten, um sie zu füllen.",
  "empty_column.list": "Diese Liste ist derzeit leer. Wenn Konten auf dieser Liste neue Beiträge veröffentlichen, werden sie hier erscheinen.",
  "empty_column.mutes": "Du hast keine Profile stummgeschaltet.",
  "empty_column.notification_requests": "Alles klar! Hier gibt es nichts. Wenn Sie neue Mitteilungen erhalten, werden diese entsprechend Ihren Einstellungen hier angezeigt.",
  "empty_column.notifications": "Du hast noch keine Benachrichtigungen. Sobald andere Personen mit dir interagieren, wirst du hier darüber informiert.",
  "empty_column.public": "Hier ist nichts zu sehen! Schreibe einen öffentlichen Beitrag oder folge Profilen von anderen Servern im Fediverse, um die Timeline zu füllen",
  "empty_state.no_results": "Keine Ergebnisse",
  "error.no_hashtag_feed_access": "Registriere dich oder melde dich an, um den Hashtag anzuschauen und ihm zu folgen.",
  "error.unexpected_crash.explanation": "Wegen eines Fehlers in unserem Code oder aufgrund einer Browser-Inkompatibilität kann diese Seite nicht korrekt angezeigt werden.",
  "error.unexpected_crash.explanation_addons": "Diese Seite konnte nicht korrekt angezeigt werden. Dieser Fehler wird wahrscheinlich durch ein Browser-Add-on oder automatische Übersetzungswerkzeuge verursacht.",
  "error.unexpected_crash.next_steps": "Versuche, die Seite neu zu laden. Wenn das nicht helfen sollte, kannst du das Webinterface von Mastodon vermutlich über einen anderen Browser erreichen – oder du verwendest eine mobile (native) App.",
  "error.unexpected_crash.next_steps_addons": "Versuche, das Add-on oder Übersetzungswerkzeug zu deaktivieren und lade die Seite anschließend neu. Sollte das Problem weiter bestehen, kannst du das Webinterface von Mastodon vermutlich über einen anderen Browser erreichen – oder du verwendest eine mobile (native) App.",
  "errors.unexpected_crash.copy_stacktrace": "Fehlerdiagnose in die Zwischenablage kopieren",
  "errors.unexpected_crash.report_issue": "Fehler melden",
  "explore.suggested_follows": "Profile",
  "explore.title": "Im Trend",
  "explore.trending_links": "Artikel",
  "explore.trending_statuses": "Beiträge",
  "explore.trending_tags": "Hashtags",
  "featured_carousel.current": "<sr>Beitrag</sr> {current, number}/{max, number}",
  "featured_carousel.header": "{count, plural, one {Angehefteter Beitrag} other {Angeheftete Beiträge}}",
  "featured_carousel.slide": "Beitrag {current, number} von {max, number}",
  "featured_tags.more_items": "+{count}",
  "featured_tags.suggestions": "In deinen letzten Beiträgen hast du {items} verwendet. Möchtest du sie zu deinen vorgestellten Hashtags hinzufügen?",
  "featured_tags.suggestions.add": "Hinzufügen",
  "featured_tags.suggestions.added": "Du kannst deine vorgestellten Hashtags jederzeit in den Einstellungen <link>Profil bearbeiten > Vorgestellte Hashtags</link> anpassen.",
  "featured_tags.suggestions.dismiss": "Nein danke",
  "filter_modal.added.context_mismatch_explanation": "Diese Filterkategorie gilt nicht für den Kontext, in welchem du auf diesen Beitrag zugegriffen hast. Wenn der Beitrag auch in diesem Kontext gefiltert werden soll, musst du den Filter bearbeiten.",
  "filter_modal.added.context_mismatch_title": "Kontext stimmt nicht überein!",
  "filter_modal.added.expired_explanation": "Diese Filterkategorie ist abgelaufen. Du musst das Ablaufdatum für diese Kategorie ändern.",
  "filter_modal.added.expired_title": "Abgelaufener Filter!",
  "filter_modal.added.review_and_configure": "Um diesen Filter zu überprüfen oder noch weiter zu konfigurieren, rufe die {settings_link} auf.",
  "filter_modal.added.review_and_configure_title": "Filtereinstellungen",
  "filter_modal.added.settings_link": "Einstellungen",
  "filter_modal.added.short_explanation": "Dieser Beitrag wurde der folgenden Filterkategorie hinzugefügt: {title}.",
  "filter_modal.added.title": "Filter hinzugefügt!",
  "filter_modal.select_filter.context_mismatch": "gilt nicht für diesen Kontext",
  "filter_modal.select_filter.expired": "abgelaufen",
  "filter_modal.select_filter.prompt_new": "Neue Kategorie: {name}",
  "filter_modal.select_filter.search": "Filter suchen oder erstellen",
  "filter_modal.select_filter.subtitle": "Einem vorhandenen Filter hinzufügen oder einen neuen erstellen",
  "filter_modal.select_filter.title": "Diesen Beitrag filtern",
  "filter_modal.title.status": "Beitrag per Filter ausblenden",
  "filter_warning.matches_filter": "Ausgeblendet wegen deines Filters „<span>{title}</span>“",
  "filtered_notifications_banner.pending_requests": "Von {count, plural, =0 {keinem Profil, das dir möglicherweise bekannt ist} one {einem Profil, das dir möglicherweise bekannt ist} other {# Profilen, die dir möglicherweise bekannt sind}}",
  "filtered_notifications_banner.title": "Gefilterte Benachrichtigungen",
  "firehose.all": "Alle Server",
  "firehose.local": "Dieser Server",
  "firehose.remote": "Externe Server",
  "follow_request.authorize": "Genehmigen",
  "follow_request.reject": "Ablehnen",
  "follow_requests.unlocked_explanation": "Auch wenn dein Konto öffentlich bzw. nicht geschützt ist, haben die Moderator*innen von {domain} gedacht, dass du diesen Follower lieber manuell bestätigen solltest.",
  "follow_suggestions.curated_suggestion": "Vom Server-Team empfohlen",
  "follow_suggestions.dismiss": "Nicht mehr anzeigen",
  "follow_suggestions.featured_longer": "Vom {domain}-Team ausgewählt",
  "follow_suggestions.friends_of_friends_longer": "Beliebt bei Leuten, denen du folgst",
  "follow_suggestions.hints.featured": "Dieses Profil wurde vom {domain}-Team ausgewählt.",
  "follow_suggestions.hints.friends_of_friends": "Dieses Profil ist bei deinen Followern beliebt.",
  "follow_suggestions.hints.most_followed": "Dieses Profil ist eines der am meisten gefolgten auf {domain}.",
  "follow_suggestions.hints.most_interactions": "Dieses Profil erhielt auf {domain} in letzter Zeit viel Aufmerksamkeit.",
  "follow_suggestions.hints.similar_to_recently_followed": "Dieses Profil ähnelt den Profilen, denen du in letzter Zeit gefolgt hast.",
  "follow_suggestions.personalized_suggestion": "Persönliche Empfehlung",
  "follow_suggestions.popular_suggestion": "Beliebte Empfehlung",
  "follow_suggestions.popular_suggestion_longer": "Beliebt auf {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Ähnelt deinen kürzlich gefolgten Profilen",
  "follow_suggestions.view_all": "Alle anzeigen",
  "follow_suggestions.who_to_follow": "Wem folgen?",
  "followed_tags": "Abonnierte Hashtags",
  "followers.hide_other_followers": "Dieses Profil möchte die weiteren Follower geheim halten",
  "followers.title": "Folgt {name}",
  "following.hide_other_following": "Dieses Profil möchte die gefolgten Profile geheim halten",
  "following.title": "Von {name} gefolgt",
  "footer.about": "Über",
  "footer.about_mastodon": "Über Mastodon",
  "footer.about_server": "Über {domain}",
  "footer.about_this_server": "Über",
  "footer.directory": "Profilverzeichnis",
  "footer.get_app": "App herunterladen",
  "footer.keyboard_shortcuts": "Tastaturkürzel",
  "footer.privacy_policy": "Datenschutzerklärung",
  "footer.source_code": "Quellcode anzeigen",
  "footer.status": "Status",
  "footer.terms_of_service": "Nutzungsbedingungen",
  "form_error.blank": "Feld darf nicht leer sein.",
  "form_field.optional": "(optional)",
  "getting_started.heading": "Auf gehts!",
  "hashtag.admin_moderation": "#{name} moderieren",
  "hashtag.browse": "Beiträge mit #{hashtag} suchen",
  "hashtag.browse_from_account": "Beiträge von @{name} mit #{hashtag} suchen",
  "hashtag.column_header.tag_mode.all": "und {additional}",
  "hashtag.column_header.tag_mode.any": "oder {additional}",
  "hashtag.column_header.tag_mode.none": "ohne {additional}",
  "hashtag.column_settings.select.no_options_message": "Keine Vorschläge gefunden",
  "hashtag.column_settings.select.placeholder": "Hashtags eingeben …",
  "hashtag.column_settings.tag_mode.all": "Alle",
  "hashtag.column_settings.tag_mode.any": "Eines von diesen",
  "hashtag.column_settings.tag_mode.none": "Keines von diesen",
  "hashtag.column_settings.tag_toggle": "Zusätzliche Hashtags dieser Spalte hinzufügen",
  "hashtag.counter_by_accounts": "{count, plural, one{{counter} Beteiligte*r} other{{counter} Beteiligte}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} Beitrag} other {{counter} Beiträge}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} Beitrag} other {{counter} Beiträge}} heute",
  "hashtag.feature": "Im Profil vorstellen",
  "hashtag.follow": "Abonnieren",
  "hashtag.mute": "#{hashtag} stummschalten",
  "hashtag.unfeature": "Im Profil nicht mehr vorstellen",
  "hashtag.unfollow": "Abbestellen",
  "hashtags.and_other": "… und {count, plural, one{# weiterer} other {# weitere}}",
  "hints.profiles.followers_may_be_missing": "Möglicherweise werden für dieses Profil nicht alle Follower angezeigt.",
  "hints.profiles.follows_may_be_missing": "Möglicherweise werden für dieses Profil nicht alle gefolgten Profile angezeigt.",
  "hints.profiles.posts_may_be_missing": "Möglicherweise werden nicht alle Beiträge von diesem Profil angezeigt.",
  "hints.profiles.see_more_followers": "Weitere Follower auf {domain} ansehen",
  "hints.profiles.see_more_follows": "Weitere gefolgte Profile auf {domain} ansehen",
  "hints.profiles.see_more_posts": "Weitere Beiträge auf {domain} ansehen",
  "home.column_settings.show_quotes": "Zitierte Beiträge anzeigen",
  "home.column_settings.show_reblogs": "Geteilte Beiträge anzeigen",
  "home.column_settings.show_replies": "Antworten zu Beiträgen anzeigen",
  "home.hide_announcements": "Ankündigungen ausblenden",
  "home.pending_critical_update.body": "Bitte aktualisiere deinen Mastodon-Server so schnell wie möglich!",
  "home.pending_critical_update.link": "Updates ansehen",
  "home.pending_critical_update.title": "Kritisches Sicherheitsupdate verfügbar!",
  "home.show_announcements": "Ankündigungen anzeigen",
  "ignore_notifications_modal.bots_title": "Benachrichtigungen von Bots ignorieren?",
  "ignore_notifications_modal.disclaimer": "Mastodon kann anderen Nutzer*innen nicht mitteilen, dass du deren Benachrichtigungen ignorierst. Das Ignorieren von Benachrichtigungen wird nicht das Absenden der Nachricht selbst unterbinden.",
  "ignore_notifications_modal.filter_instead": "Stattdessen filtern",
  "ignore_notifications_modal.filter_to_act_users": "Du wirst weiterhin die Möglichkeit haben, andere Nutzer*innen zu akzeptieren, abzulehnen oder zu melden",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtern hilft, mögliches Durcheinander zu vermeiden",
  "ignore_notifications_modal.filter_to_review_separately": "Gefilterte Benachrichtigungen können separat überprüft werden",
  "ignore_notifications_modal.ignore": "Benachrichtigungen ignorieren",
  "ignore_notifications_modal.limited_accounts_title": "Benachrichtigungen von moderierten Konten ignorieren?",
  "ignore_notifications_modal.new_accounts_title": "Benachrichtigungen von neuen Konten ignorieren?",
  "ignore_notifications_modal.not_followers_title": "Benachrichtigungen von Profilen ignorieren, die dir nicht folgen?",
  "ignore_notifications_modal.not_following_title": "Benachrichtigungen von Profilen ignorieren, denen du nicht folgst?",
  "ignore_notifications_modal.private_mentions_title": "Benachrichtigungen von unerwünschten privaten Erwähnungen ignorieren?",
  "info_button.label": "Hilfe",
  "info_button.what_is_alt_text": "<h1>Was ist Alt-Text?</h1> <p>Der Alt-Text bietet Bildbeschreibungen für blinde und sehbehinderte Menschen, aber auch für alle mit einer schlechten Internetverbindung und wer einen zusätzlichen Kontext möchten.</p> <p>Du kannst die Barrierefreiheit und Verständlichkeit für alle verbessern, indem du eine klare, genaue und objektive Bildbeschreibung erstellst.</p> <ul> <li>Erfasse wichtige Elemente</li> <li>Fasse Texte bildlich zusammen</li> <li>Verwende einen korrekten Satzbau</li> <li>Vermeide unwichtige und überflüssige Informationen</li> <li>Konzentriere dich bei komplexen Darstellungen (z. B. bei Diagrammen oder Karten) auf Veränderungen und Schlüsselwörter</li> </ul>",
  "interaction_modal.action": "Melde dich auf deinem Mastodon-Server an, damit du mit dem Beitrag von {name} interagieren kannst.",
  "interaction_modal.action_follow": "Melde dich auf deinem Mastodon-Server an, damit du {name} folgen kannst.",
  "interaction_modal.go": "Los",
  "interaction_modal.no_account_yet": "Du hast noch kein Konto?",
  "interaction_modal.on_another_server": "Auf anderem Server",
  "interaction_modal.on_this_server": "Auf diesem Server",
  "interaction_modal.title": "Melde dich an, um fortzufahren",
  "interaction_modal.username_prompt": "Z. B. {example}",
  "intervals.full.days": "{number, plural, one {# Tag} other {# Tage}}",
  "intervals.full.hours": "{number, plural, one {# Stunde} other {# Stunden}}",
  "intervals.full.minutes": "{number, plural, one {# Minute} other {# Minuten}}",
  "keyboard_shortcuts.back": "Zurücknavigieren",
  "keyboard_shortcuts.blocked": "Blockierte Profile öffnen",
  "keyboard_shortcuts.boost": "Beitrag teilen",
  "keyboard_shortcuts.column": "Aktuelle Spalte fokussieren",
  "keyboard_shortcuts.compose": "Eingabefeld fokussieren",
  "keyboard_shortcuts.description": "Beschreibung",
  "keyboard_shortcuts.direct": "Private Erwähnungen öffnen",
  "keyboard_shortcuts.down": "Auswahl nach unten bewegen",
  "keyboard_shortcuts.enter": "Beitrag öffnen",
  "keyboard_shortcuts.explore": "Trends aufrufen",
  "keyboard_shortcuts.favourite": "Beitrag favorisieren",
  "keyboard_shortcuts.favourites": "Favoriten öffnen",
  "keyboard_shortcuts.federated": "Föderierte Timeline öffnen",
  "keyboard_shortcuts.heading": "Tastenkürzel",
  "keyboard_shortcuts.home": "Startseite öffnen",
  "keyboard_shortcuts.hotkey": "Tastenkürzel",
  "keyboard_shortcuts.keys.alt": "Alt",
  "keyboard_shortcuts.keys.backspace": "Backspace",
  "keyboard_shortcuts.keys.enter": "Eingabetaste",
  "keyboard_shortcuts.keys.esc": "Esc",
  "keyboard_shortcuts.keys.page_down": "Bild ab",
  "keyboard_shortcuts.keys.page_up": "Bild auf",
  "keyboard_shortcuts.legend": "Tastenkürzel anzeigen (diese Seite)",
  "keyboard_shortcuts.load_more": "Schaltfläche „Mehr laden“ fokussieren",
  "keyboard_shortcuts.local": "Lokale Timeline öffnen",
  "keyboard_shortcuts.mention": "Profil erwähnen",
  "keyboard_shortcuts.muted": "Stummgeschaltete Profile öffnen",
  "keyboard_shortcuts.my_profile": "Eigenes Profil öffnen",
  "keyboard_shortcuts.notifications": "Benachrichtigungen öffnen",
  "keyboard_shortcuts.open_media": "Medien öffnen",
  "keyboard_shortcuts.pinned": "Liste angehefteter Beiträge öffnen",
  "keyboard_shortcuts.profile": "Profil aufrufen",
  "keyboard_shortcuts.quote": "Beitrag zitieren",
  "keyboard_shortcuts.reply": "Beitrag beantworten",
  "keyboard_shortcuts.requests": "Follower-Anfragen aufrufen",
  "keyboard_shortcuts.search": "Eingabefeld / Suche fokussieren",
  "keyboard_shortcuts.spoilers": "Feld für Inhaltswarnung anzeigen / ausblenden",
  "keyboard_shortcuts.start": "„Auf gehts!“ öffnen",
  "keyboard_shortcuts.toggle_hidden": "Beitrag hinter Inhaltswarnung anzeigen / ausblenden",
  "keyboard_shortcuts.toggle_sensitivity": "Medien anzeigen / ausblenden",
  "keyboard_shortcuts.toot": "Neuen Beitrag erstellen",
  "keyboard_shortcuts.top": "Zum Listenanfang springen",
  "keyboard_shortcuts.translate": "Beitrag übersetzen",
  "keyboard_shortcuts.unfocus": "Eingabefeld / Suche nicht mehr fokussieren",
  "keyboard_shortcuts.up": "Auswahl nach oben bewegen",
  "learn_more_link.got_it": "Verstanden",
  "learn_more_link.learn_more": "Mehr erfahren",
  "lightbox.close": "Schließen",
  "lightbox.next": "Vor",
  "lightbox.previous": "Zurück",
  "lightbox.zoom_in": "In Originalgröße anzeigen",
  "lightbox.zoom_out": "In angepasster Größe anzeigen",
  "limited_account_hint.action": "Profil trotzdem anzeigen",
  "limited_account_hint.title": "Dieses Profil oder dieser Server wurde von den Moderator*innen von {domain} ausgeblendet.",
  "link_preview.author": "Von {name}",
  "link_preview.more_from_author": "Mehr von {name}",
  "link_preview.shares": "{count, plural, one {{counter} Beitrag} other {{counter} Beiträge}}",
  "lists.add_member": "Hinzufügen",
  "lists.add_to_list": "Zur Liste hinzufügen",
  "lists.add_to_lists": "{name} zu Listen hinzufügen",
  "lists.create": "Erstellen",
  "lists.create_a_list_to_organize": "Erstelle eine neue Liste, um deine Startseite zu organisieren",
  "lists.create_list": "Liste erstellen",
  "lists.delete": "Liste löschen",
  "lists.done": "Fertig",
  "lists.edit": "Liste bearbeiten",
  "lists.exclusive": "Mitglieder auf der Startseite ausblenden",
  "lists.exclusive_hint": "Profile, die sich auf dieser Liste befinden, werden nicht im Feed deiner Startseite angezeigt, damit deren Beiträge nicht doppelt erscheinen.",
  "lists.find_users_to_add": "Suche nach Profilen, um sie hinzuzufügen",
  "lists.list_members_count": "{count, plural, one {# Mitglied} other {# Mitglieder}}",
  "lists.list_name": "Titel der Liste",
  "lists.new_list_name": "Neuer Listentitel",
  "lists.no_lists_yet": "Noch keine Listen vorhanden.",
  "lists.no_members_yet": "Keine Mitglieder vorhanden.",
  "lists.no_results_found": "Keine Suchergebnisse.",
  "lists.remove_member": "Entfernen",
  "lists.replies_policy.followed": "alle folgenden Profile",
  "lists.replies_policy.list": "Mitglieder der Liste",
  "lists.replies_policy.none": "niemanden",
  "lists.save": "Speichern",
  "lists.search": "Suchen",
  "lists.show_replies_to": "Antworten von Listenmitgliedern einbeziehen an …",
  "load_pending": "{count, plural, one {# neuer Beitrag} other {# neue Beiträge}}",
  "loading_indicator.label": "Lädt …",
  "media_gallery.hide": "Ausblenden",
  "moved_to_account_banner.text": "Dein Konto {disabledAccount} ist derzeit deaktiviert, weil du zu {movedToAccount} umgezogen bist.",
  "mute_modal.hide_from_notifications": "Auch aus den Benachrichtigungen entfernen",
  "mute_modal.hide_options": "Optionen ausblenden",
  "mute_modal.indefinite": "Dauerhaft, bis ich die Stummschaltung aufhebe",
  "mute_modal.show_options": "Optionen anzeigen",
  "mute_modal.they_can_mention_and_follow": "Das Profil wird dich weiterhin erwähnen und dir folgen können, aber du wirst davon nichts sehen.",
  "mute_modal.they_wont_know": "Das Profil wird nicht erkennen können, dass du es stummgeschaltet hast.",
  "mute_modal.title": "Profil stummschalten?",
  "mute_modal.you_wont_see_mentions": "Du wirst keine Beiträge sehen, die dieses Profil erwähnen.",
  "mute_modal.you_wont_see_posts": "Deine Beiträge können von diesem stummgeschalteten Profil weiterhin gesehen werden, aber du wirst dessen Beiträge nicht mehr sehen.",
  "navigation_bar.about": "Über",
  "navigation_bar.account_settings": "Passwort & Sicherheit",
  "navigation_bar.administration": "Administration",
  "navigation_bar.advanced_interface": "Erweitertes Webinterface öffnen",
  "navigation_bar.automated_deletion": "Automatisiertes Löschen",
  "navigation_bar.blocks": "Blockierte Profile",
  "navigation_bar.bookmarks": "Lesezeichen",
  "navigation_bar.collections": "Sammlungen",
  "navigation_bar.direct": "Private Erwähnungen",
  "navigation_bar.domain_blocks": "Blockierte Domains",
  "navigation_bar.favourites": "Favoriten",
  "navigation_bar.filters": "Stummgeschaltete Wörter",
  "navigation_bar.follow_requests": "Follower-Anfragen",
  "navigation_bar.followed_tags": "Abonnierte Hashtags",
  "navigation_bar.follows_and_followers": "Follower & Folge ich",
  "navigation_bar.import_export": "Importieren & exportieren",
  "navigation_bar.lists": "Listen",
  "navigation_bar.live_feed_local": "Live-Feed (Dieser Server)",
  "navigation_bar.live_feed_public": "Live-Feed (Alle Server)",
  "navigation_bar.logout": "Abmelden",
  "navigation_bar.main": "Hauptmenü",
  "navigation_bar.moderation": "Moderation",
  "navigation_bar.more": "Mehr",
  "navigation_bar.mutes": "Stummgeschaltete Profile",
  "navigation_bar.opened_in_classic_interface": "Beiträge, Konten und andere bestimmte Seiten werden standardmäßig im klassischen Webinterface geöffnet.",
  "navigation_bar.preferences": "Einstellungen",
  "navigation_bar.privacy_and_reach": "Datenschutz & Reichweite",
  "navigation_bar.search": "Suche",
  "navigation_bar.search_trends": "Suche / Trends",
  "navigation_panel.collapse_followed_tags": "Menü für abonnierte Hashtags schließen",
  "navigation_panel.collapse_lists": "Listen-Menü schließen",
  "navigation_panel.expand_followed_tags": "Menü für abonnierte Hashtags öffnen",
  "navigation_panel.expand_lists": "Listen-Menü öffnen",
  "not_signed_in_indicator.not_signed_in": "Du musst dich anmelden, um auf diesen Inhalt zugreifen zu können.",
  "notification.added_to_collection": "{name} hat dich einer Sammlung hinzugefügt",
  "notification.admin.report": "{name} meldete {target}",
  "notification.admin.report_account": "{name} meldete {count, plural, one {einen Beitrag} other {# Beiträge}} von {target} wegen {category}",
  "notification.admin.report_account_other": "{name} meldete {count, plural, one {einen Beitrag} other {# Beiträge}} von {target}",
  "notification.admin.report_statuses": "{name} meldete {target} wegen {category}",
  "notification.admin.report_statuses_other": "{name} meldete {target}",
  "notification.admin.sign_up": "{name} registrierte sich",
  "notification.admin.sign_up.name_and_others": "{name} und {count, plural, one {# weiteres Profil} other {# weitere Profile}} registrierten sich",
  "notification.annual_report.message": "Dein #Wrapstodon für {year} erwartet dich! Lass deine Highlights und unvergesslichen Momente auf Mastodon erneut aufleben!",
  "notification.annual_report.view": "#Wrapstodon ansehen",
  "notification.collection_update": "{name} hat eine Sammlung bearbeitet, in der du vorgestellt wirst",
  "notification.favourite": "{name} favorisierte deinen Beitrag",
  "notification.favourite.name_and_others_with_link": "{name} und <a>{count, plural, one {# weiteres Profil} other {# weitere Profile}}</a> favorisierten deinen Beitrag",
  "notification.favourite_pm": "{name} favorisierte deine private Erwähnung",
  "notification.favourite_pm.name_and_others_with_link": "{name} und <a>{count, plural, one {# weiteres Profil} other {# weitere Profile}}</a> favorisierten deine private Erwähnung",
  "notification.follow": "{name} folgt dir",
  "notification.follow.name_and_others": "{name} und <a>{count, plural, one {# weiteres Profil} other {# weitere Profile}}</a> folgen dir",
  "notification.follow_request": "{name} möchte dir folgen",
  "notification.follow_request.name_and_others": "{name} und {count, plural, one {# weiteres Profil} other {# weitere Profile}} möchten dir folgen",
  "notification.label.mention": "Erwähnung",
  "notification.label.private_mention": "Private Erwähnung",
  "notification.label.private_reply": "Private Antwort",
  "notification.label.quote": "{name} zitierte deinen Beitrag",
  "notification.label.reply": "Antwort",
  "notification.mention": "Erwähnung",
  "notification.mentioned_you": "{name} erwähnte dich",
  "notification.moderation-warning.learn_more": "Mehr erfahren",
  "notification.moderation_warning": "Du wurdest von den Moderator*innen verwarnt",
  "notification.moderation_warning.action_delete_statuses": "Einige deiner Beiträge sind entfernt worden.",
  "notification.moderation_warning.action_disable": "Dein Konto wurde deaktiviert.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Einige deiner Beiträge haben eine Inhaltswarnung erhalten.",
  "notification.moderation_warning.action_none": "Dein Konto ist von den Moderator*innen verwarnt worden.",
  "notification.moderation_warning.action_sensitive": "Deine zukünftigen Beiträge werden mit einer Inhaltswarnung versehen.",
  "notification.moderation_warning.action_silence": "Dein Konto wurde eingeschränkt.",
  "notification.moderation_warning.action_suspend": "Dein Konto wurde gesperrt.",
  "notification.own_poll": "Deine Umfrage ist beendet",
  "notification.poll": "Eine Umfrage, an der du teilgenommen hast, ist beendet",
  "notification.quoted_update": "{name} bearbeitete einen von dir zitierten Beitrag",
  "notification.reblog": "{name} teilte deinen Beitrag",
  "notification.reblog.name_and_others_with_link": "{name} und <a>{count, plural, one {# weiteres Profil} other {# weitere Profile}}</a> teilten deinen Beitrag",
  "notification.relationships_severance_event": "Verbindung zu {name} verloren",
  "notification.relationships_severance_event.account_suspension": "Administrator*innen von {from} haben den Zugriff auf den externen Server {target} gesperrt. Das bedeutet, dass du keine Inhalte mehr von dort erhältst. Du kannst auch nicht mehr mit den Profilen dieses Servers interagieren.",
  "notification.relationships_severance_event.domain_block": "Ein Admin von {from} hat {target} gesperrt – darunter {followersCount} deiner Follower und {followingCount, plural, one {# Konto, dem} other {# Konten, denen}} du folgst.",
  "notification.relationships_severance_event.learn_more": "Mehr erfahren",
  "notification.relationships_severance_event.user_domain_block": "Du hast {target} blockiert – {followersCount} deiner Follower und {followingCount, plural, one {# Konto, dem} other {# Konten, denen}} du folgst, wurden entfernt.",
  "notification.status": "{name} veröffentlichte …",
  "notification.update": "{name} bearbeitete einen Beitrag",
  "notification_requests.accept": "Akzeptieren",
  "notification_requests.accept_multiple": "{count, plural, one {# Anfrage akzeptieren …} other {# Anfragen akzeptieren …}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Anfrage akzeptieren} other {Anfragen akzeptieren}}",
  "notification_requests.confirm_accept_multiple.message": "Du bist dabei, {{count, plural, one {eine Benachrichtigungsanfrage} other {# Benachrichtigungsanfragen}} zu akzeptieren. Möchtest du wirklich fortfahren?",
  "notification_requests.confirm_accept_multiple.title": "Benachrichtigungsanfragen akzeptieren?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Anfrage ablehnen} other {Anfragen ablehnen}}",
  "notification_requests.confirm_dismiss_multiple.message": "Du bist dabei, {count, plural, one {eine Benachrichtigungsanfrage} other {# Benachrichtigungsanfragen}} abzulehnen. Du wirst nicht mehr ohne Weiteres auf {count, plural, one {sie} other {sie}} zugreifen können. Möchtest du wirklich fortfahren?",
  "notification_requests.confirm_dismiss_multiple.title": "Benachrichtigungsanfragen ablehnen?",
  "notification_requests.dismiss": "Ablehnen",
  "notification_requests.dismiss_multiple": "{count, plural, one {# Anfrage ablehnen …} other {# Anfragen ablehnen …}}",
  "notification_requests.edit_selection": "Bearbeiten",
  "notification_requests.exit_selection": "Fertig",
  "notification_requests.explainer_for_limited_account": "Benachrichtigungen von diesem Konto wurden gefiltert, weil es durch Moderator*innen eingeschränkt wurde.",
  "notification_requests.explainer_for_limited_remote_account": "Benachrichtigungen von diesem Konto wurden gefiltert, weil deren Konto oder Server durch Moderator*innen eingeschränkt wurde.",
  "notification_requests.maximize": "Maximieren",
  "notification_requests.minimize_banner": "Banner für gefilterte Benachrichtigungen minimieren",
  "notification_requests.notifications_from": "Benachrichtigungen von {name}",
  "notification_requests.title": "Gefilterte Benachrichtigungen",
  "notification_requests.view": "Benachrichtigungen anzeigen",
  "notifications.clear": "Benachrichtigungen löschen",
  "notifications.clear_confirmation": "Möchtest du wirklich alle Benachrichtigungen für immer löschen?",
  "notifications.clear_title": "Benachrichtigungen löschen?",
  "notifications.column_settings.admin.report": "Neue Meldungen:",
  "notifications.column_settings.admin.sign_up": "Neue Registrierungen:",
  "notifications.column_settings.alert": "Desktop-Benachrichtigungen",
  "notifications.column_settings.collections": "Sammlungen:",
  "notifications.column_settings.favourite": "Favoriten:",
  "notifications.column_settings.filter_bar.advanced": "Alle Filterkategorien anzeigen",
  "notifications.column_settings.filter_bar.category": "Filterleiste",
  "notifications.column_settings.follow": "Neue Follower:",
  "notifications.column_settings.follow_request": "Neue Follower-Anfragen:",
  "notifications.column_settings.group": "Gruppieren",
  "notifications.column_settings.mention": "Erwähnungen:",
  "notifications.column_settings.poll": "Umfrageergebnisse:",
  "notifications.column_settings.push": "Push-Benachrichtigungen",
  "notifications.column_settings.quote": "Zitierte Beiträge:",
  "notifications.column_settings.reblog": "Geteilte Beiträge:",
  "notifications.column_settings.show": "Im Feed „Benachrichtigungen“ anzeigen",
  "notifications.column_settings.sound": "Ton abspielen",
  "notifications.column_settings.status": "Neue Beiträge:",
  "notifications.column_settings.unread_notifications.category": "Ungelesene Benachrichtigungen",
  "notifications.column_settings.unread_notifications.highlight": "Ungelesene Benachrichtigungen hervorheben",
  "notifications.column_settings.update": "Überarbeitete Beiträge:",
  "notifications.filter.all": "Alles",
  "notifications.filter.boosts": "Geteilte Beiträge",
  "notifications.filter.collections": "Sammlungen",
  "notifications.filter.favourites": "Favoriten",
  "notifications.filter.follows": "Neue Follower",
  "notifications.filter.mentions": "Erwähnungen",
  "notifications.filter.polls": "Umfrageergebnisse",
  "notifications.filter.statuses": "Neue Beiträge von abonnierten Profilen",
  "notifications.grant_permission": "Berechtigung erteilen.",
  "notifications.group": "{count} Benachrichtigungen",
  "notifications.mark_as_read": "Alle Benachrichtigungen als gelesen markieren",
  "notifications.permission_denied": "Desktop-Benachrichtigungen können aufgrund einer zuvor verweigerten Berechtigung nicht aktiviert werden",
  "notifications.permission_denied_alert": "Desktop-Benachrichtigungen können nicht aktiviert werden, da die Browser-Berechtigung zuvor verweigert wurde",
  "notifications.permission_required": "Desktop-Benachrichtigungen sind nicht verfügbar, da die erforderliche Berechtigung nicht erteilt wurde.",
  "notifications.policy.accept": "Akzeptieren",
  "notifications.policy.accept_hint": "In Benachrichtigungen anzeigen",
  "notifications.policy.drop": "Ignorieren",
  "notifications.policy.drop_hint": "Ins Nirwana befördern und auf Nimmerwiedersehen!",
  "notifications.policy.filter": "Filtern",
  "notifications.policy.filter_bots_hint": "Als automatisiert gekennzeichnete Konten",
  "notifications.policy.filter_bots_title": "Bots",
  "notifications.policy.filter_hint": "Im separaten Feed „Gefilterte Benachrichtigungen“ anzeigen",
  "notifications.policy.filter_limited_accounts_hint": "Durch Server-Moderator*innen eingeschränkte Profile",
  "notifications.policy.filter_limited_accounts_title": "eingeschränkten Konten",
  "notifications.policy.filter_new_accounts.hint": "Konto {days, plural, one {seit gestern} other {in den vergangenen # Tagen}} registriert",
  "notifications.policy.filter_new_accounts_title": "neuen Profilen",
  "notifications.policy.filter_not_followers_hint": "Einschließlich Profilen, die mir seit weniger als {days, plural, one {einem Tag} other {# Tagen}} folgen",
  "notifications.policy.filter_not_followers_title": "Profilen, die mir nicht folgen",
  "notifications.policy.filter_not_following_hint": "… bis ich sie manuell genehmige",
  "notifications.policy.filter_not_following_title": "Profilen, denen ich nicht folge",
  "notifications.policy.filter_private_mentions_hint": "… solange sie keine Antwort auf meine Erwähnungen sind – oder ich den Profilen nicht folge",
  "notifications.policy.filter_private_mentions_title": "unerwünschten privaten Erwähnungen",
  "notifications.policy.title": "Benachrichtigungen verwalten von …",
  "notifications_permission_banner.enable": "Aktiviere Desktop-Benachrichtigungen",
  "notifications_permission_banner.how_to_control": "Aktiviere Desktop-Benachrichtigungen, um Mitteilungen zu erhalten, wenn Mastodon nicht geöffnet ist. Du kannst für jede Kategorie einstellen, ob du Desktop-Benachrichtigungen erhalten möchtest. Sobald sie aktiviert sind, klicke dafür auf das {icon} -Symbol.",
  "notifications_permission_banner.title": "Nichts verpassen",
  "onboarding.follows.back": "Zurück",
  "onboarding.follows.empty": "Bedauerlicherweise können aktuell keine Ergebnisse angezeigt werden. Du kannst die Suche verwenden oder den Reiter „Entdecken“ auswählen, um neue Leute zum Folgen zu finden – oder du versuchst es später erneut.",
  "onboarding.follows.next": "Nächster Schritt: Profil einrichten",
  "onboarding.follows.search": "Suchen",
  "onboarding.follows.title": "Folge Profilen, um loszulegen",
  "onboarding.profile.discoverable": "Mein Profil darf entdeckt werden",
  "onboarding.profile.discoverable_hint": "Wenn du entdeckt werden möchtest, dann können deine Beiträge in Suchergebnissen und Trends erscheinen. Dein Profil kann ebenfalls anderen mit ähnlichen Interessen vorgeschlagen werden.",
  "onboarding.profile.display_name": "Anzeigename",
  "onboarding.profile.display_name_hint": "Dein richtiger Name oder dein Fantasiename …",
  "onboarding.profile.finish": "Fertig",
  "onboarding.profile.note": "Über mich",
  "onboarding.profile.note_hint": "Du kannst andere @Profile erwähnen oder #Hashtags verwenden …",
  "onboarding.profile.title": "Profil einrichten",
  "onboarding.profile.upload_avatar": "Profilbild hochladen",
  "onboarding.profile.upload_header": "Titelbild hochladen",
  "password_confirmation.exceeds_maxlength": "Passwortbestätigung überschreitet die maximal erlaubte Zeichenanzahl",
  "password_confirmation.mismatching": "Passwortbestätigung stimmt nicht überein",
  "picture_in_picture.restore": "Zurücksetzen",
  "poll.closed": "Beendet",
  "poll.refresh": "Aktualisieren",
  "poll.reveal": "Ergebnisse ansehen",
  "poll.total_people": "{count, plural, one {# Person} other {# Personen}}",
  "poll.total_votes": "{count, plural, one {# Stimme} other {# Stimmen}}",
  "poll.vote": "Abstimmen",
  "poll.voted": "Du hast für diese Auswahl gestimmt",
  "poll.votes": "{votes, plural, one {# Stimme} other {# Stimmen}}",
  "poll_button.add_poll": "Umfrage erstellen",
  "poll_button.remove_poll": "Umfrage entfernen",
  "privacy.change": "Sichtbarkeit anpassen",
  "privacy.direct.long": "Nur in diesem Beitrag erwähnte Profile",
  "privacy.direct.short": "Private Erwähnung",
  "privacy.private.long": "Nur deine eigenen Follower",
  "privacy.private.short": "Follower",
  "privacy.public.long": "Alle innerhalb und außerhalb von Mastodon",
  "privacy.public.short": "Öffentlich",
  "privacy.quote.anyone": "{visibility} – Zitieren erlaubt",
  "privacy.quote.disabled": "{visibility} – Zitieren deaktiviert",
  "privacy.quote.limited": "{visibility} – nur Follower",
  "privacy.unlisted.additional": "Das Verhalten ist wie bei „Öffentlich“, jedoch gibt es einige Einschränkungen. Der Beitrag wird nicht in „Live-Feeds“, „Erkunden“, Hashtags oder über die Mastodon-Suchfunktion auffindbar sein – selbst wenn die zugehörige Einstellung aktiviert wurde.",
  "privacy.unlisted.long": "Verborgen vor Suchen, Trends und öffentlichen Timelines",
  "privacy.unlisted.short": "Öffentlich (still)",
  "privacy_policy.last_updated": "Stand: {date}",
  "privacy_policy.title": "Datenschutzerklärung",
  "quote_error.edit": "Beim Bearbeiten eines vorhandenen Beitrags können keine Zitate hinzugefügt werden.",
  "quote_error.poll": "Zitieren ist bei Umfragen nicht erlaubt.",
  "quote_error.private_mentions": "Zitieren ist bei privaten Erwähnungen nicht erlaubt.",
  "quote_error.quote": "Es darf nur ein Beitrag zitiert werden.",
  "quote_error.unauthorized": "Du bist nicht berechtigt, diesen Beitrag zu zitieren.",
  "quote_error.upload": "Zitieren ist mit Medien-Anhängen nicht möglich.",
  "recommended": "Empfohlen",
  "refresh": "Aktualisieren",
  "regeneration_indicator.please_stand_by": "Bitte warten.",
  "regeneration_indicator.preparing_your_home_feed": "Startseite wird vorbereitet …",
  "relative_time.days": "{number} T.",
  "relative_time.full.days": "vor {number, plural, one {# Tag} other {# Tagen}}",
  "relative_time.full.hours": "vor {number, plural, one {# Stunde} other {# Stunden}}",
  "relative_time.full.just_now": "soeben",
  "relative_time.full.minutes": "vor {number, plural, one {# Minute} other {# Minuten}}",
  "relative_time.full.seconds": "vor {number, plural, one {1 Sekunde} other {# Sekunden}}",
  "relative_time.hours": "{number} Std.",
  "relative_time.just_now": "jetzt",
  "relative_time.minutes": "{number} Min.",
  "relative_time.seconds": "{number} Sek.",
  "relative_time.today": "heute",
  "remove_quote_hint.button_label": "Verstanden",
  "remove_quote_hint.message": "Klicke dafür im Beitrag auf „{icon} Mehr“.",
  "remove_quote_hint.title": "Deinen zitierten Beitrag aus diesem Beitrag entfernen?",
  "reply_indicator.attachments": "{count, plural, one {# Anhang} other {# Anhänge}}",
  "reply_indicator.cancel": "Abbrechen",
  "reply_indicator.poll": "Umfrage",
  "report.block": "Blockieren",
  "report.block_explanation": "Du wirst keine Beiträge mehr von diesem Konto sehen. Das blockierte Konto wird deine Beiträge nicht mehr sehen oder dir folgen können. Die Person könnte mitbekommen, dass du sie blockiert hast.",
  "report.categories.legal": "Rechtliches",
  "report.categories.other": "Andere",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Der Inhalt verletzt eine oder mehrere Serverregeln",
  "report.category.subtitle": "Wähle die passendste Kategorie",
  "report.category.title_account": "Sag uns, was das Problem mit diesem Profil ist",
  "report.category.title_collection": "Sag uns, was das Problem mit dieser Sammlung ist",
  "report.category.title_status": "Sag uns, was das Problem mit diesem Beitrag ist",
  "report.close": "Fertig",
  "report.comment.title": "Gibt es noch etwas, das wir wissen sollten?",
  "report.forward": "Meldung auch an den externen Server {target} weiterleiten",
  "report.forward_hint": "Das gemeldete Konto befindet sich auf einem anderen Server. Soll zusätzlich eine anonymisierte Kopie deiner Meldung an diesen Server geschickt werden?",
  "report.mute": "Stummschalten",
  "report.mute_explanation": "Du wirst keine Beiträge mehr von diesem Konto sehen. Das stummgeschaltete Konto wird dir weiterhin folgen und deine Beiträge sehen können. Die Person wird nicht mitbekommen, dass du sie stummgeschaltet hast.",
  "report.next": "Weiter",
  "report.placeholder": "Ergänzende Hinweise",
  "report.reasons.dislike": "Das gefällt mir nicht",
  "report.reasons.dislike_description": "Das ist etwas, das du nicht sehen möchtest",
  "report.reasons.legal": "Das ist rechtswidrig",
  "report.reasons.legal_description": "Du glaubst, dass es gegen die Gesetze deines Landes oder des Landes des Servers verstößt",
  "report.reasons.other": "Es ist etwas anderes",
  "report.reasons.other_description": "Der Vorfall passt zu keiner dieser Kategorien",
  "report.reasons.spam": "Das ist Spam",
  "report.reasons.spam_description": "Bösartige Links, gefälschtes Engagement oder sich wiederholende Antworten",
  "report.reasons.violation": "Das verstößt gegen Serverregeln",
  "report.reasons.violation_description": "Du bist dir sicher, dass eine bestimmte Regel gebrochen wurde",
  "report.rules.subtitle": "Wähle alle zutreffenden Inhalte aus",
  "report.rules.title": "Gegen welche Regeln wurde verstoßen?",
  "report.statuses.subtitle": "Wähle alle zutreffenden Inhalte aus",
  "report.statuses.title": "Gibt es Beiträge, die diese Meldung stützen?",
  "report.submission_error": "Meldung konnte nicht übermittelt werden",
  "report.submission_error_details": "Bitte prüfe deine Internetverbindung und probiere es später erneut.",
  "report.submit": "Senden",
  "report.target": "{target} melden",
  "report.thanks.take_action": "Das sind deine Möglichkeiten zu bestimmen, was du auf Mastodon sehen möchtest:",
  "report.thanks.take_action_actionable": "Während wir den Vorfall überprüfen, kannst du gegen @{name} weitere Maßnahmen ergreifen:",
  "report.thanks.title": "Möchtest du das nicht mehr sehen?",
  "report.thanks.title_actionable": "Vielen Dank für die Meldung! Wir werden uns das ansehen.",
  "report.unfollow": "@{name} entfolgen",
  "report.unfollow_explanation": "Du folgst diesem Konto. Um die Beiträge nicht mehr auf deiner Startseite zu sehen, entfolge dem Konto.",
  "report_notification.attached_statuses": "{count, plural, one {{count} angehangener Beitrag} other {{count} angehängte Beiträge}}",
  "report_notification.categories.legal": "Rechtliches",
  "report_notification.categories.legal_sentence": "rechtswidrigem Inhalt",
  "report_notification.categories.other": "Nicht aufgeführt",
  "report_notification.categories.other_sentence": "etwas anderem",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "Spam",
  "report_notification.categories.violation": "Regelverstoß",
  "report_notification.categories.violation_sentence": "Verstoß gegen die Serverregeln",
  "report_notification.open": "Meldung öffnen",
  "search.clear": "Suchanfrage löschen",
  "search.no_recent_searches": "Keine früheren Suchanfragen",
  "search.placeholder": "Suchen",
  "search.quick_action.account_search": "Profile passend zu {x}",
  "search.quick_action.go_to_account": "Profil {x} aufrufen",
  "search.quick_action.go_to_hashtag": "Hashtag {x} aufrufen",
  "search.quick_action.open_url": "URL in Mastodon öffnen",
  "search.quick_action.status_search": "Beiträge passend zu {x}",
  "search.search_or_paste": "Suche eingeben oder URL einfügen",
  "search_popout.full_text_search_disabled_message": "Auf {domain} nicht verfügbar.",
  "search_popout.full_text_search_logged_out_message": "Nur verfügbar, wenn angemeldet.",
  "search_popout.language_code": "ISO-Sprachcode",
  "search_popout.options": "Suchoptionen",
  "search_popout.quick_actions": "Schnellaktionen",
  "search_popout.recent": "Frühere Suchanfragen",
  "search_popout.specific_date": "genaues Datum",
  "search_popout.user": "Profil",
  "search_results.accounts": "Profile",
  "search_results.all": "Alles",
  "search_results.collections": "Sammlungen",
  "search_results.hashtags": "Hashtags",
  "search_results.no_results": "Keine Ergebnisse.",
  "search_results.no_search_yet": "Suche nach Beiträgen, Profilen oder Hashtags.",
  "search_results.see_all": "Alle ansehen",
  "search_results.statuses": "Beiträge",
  "search_results.title": "Nach „{q}“ suchen",
  "server_banner.about_active_users": "Personen, die diesen Server in den vergangenen 30 Tagen verwendet haben (monatlich aktive Nutzer*innen)",
  "server_banner.active_users": "aktive Profile",
  "server_banner.administered_by": "Verwaltet von:",
  "server_banner.is_one_of_many": "{domain} ist einer von vielen unabhängigen Mastodon-Servern, mit dem du dich im Fediverse beteiligen kannst.",
  "server_banner.more_about_this_server": "Mehr über diesen Server",
  "server_banner.server_stats": "Serverstatistik:",
  "sign_in_banner.create_account": "Konto erstellen",
  "sign_in_banner.follow_anyone": "Du kannst jedem im Fediverse folgen und alles in chronologischer Reihenfolge sehen. Keine Algorithmen, Werbung oder Clickbaits vorhanden.",
  "sign_in_banner.mastodon_is": "Mastodon ist der beste Zugang, um auf dem Laufenden zu bleiben.",
  "sign_in_banner.sign_in": "Anmelden",
  "sign_in_banner.sso_redirect": "Anmelden oder registrieren",
  "skip_links.hotkey": "<span>Tastenkürzel</span> {hotkey}",
  "skip_links.skip_to_content": "Zum Hauptinhalt wechseln",
  "skip_links.skip_to_navigation": "Zur Hauptnavigation wechseln",
  "status.admin_account": "@{name} moderieren",
  "status.admin_domain": "{domain} moderieren",
  "status.admin_status": "Beitrag moderieren",
  "status.all_disabled": "Teilen und Zitieren sind deaktiviert",
  "status.block": "@{name} blockieren",
  "status.bookmark": "Lesezeichen setzen",
  "status.cancel_reblog_private": "Nicht mehr teilen",
  "status.cannot_quote": "Diesen Beitrag darfst du nicht zitieren",
  "status.cannot_reblog": "Dieser Beitrag kann nicht geteilt werden",
  "status.contains_quote": "Enthält zitierten Beitrag",
  "status.context.loading": "Weitere Antworten laden",
  "status.context.loading_error": "Weitere Antworten konnten nicht geladen werden",
  "status.context.loading_success": "Neue Antworten geladen",
  "status.context.more_replies_found": "Weitere Antworten verfügbar",
  "status.context.retry": "Erneut versuchen",
  "status.context.show": "Anzeigen",
  "status.continued_thread": "Fortgeführter Thread",
  "status.copy": "Link zum Beitrag kopieren",
  "status.delete": "Beitrag löschen",
  "status.delete.success": "Beitrag gelöscht",
  "status.detailed_status": "Detaillierte Ansicht der Unterhaltung",
  "status.direct": "@{name} privat erwähnen",
  "status.direct_indicator": "Private Erwähnung",
  "status.edit": "Beitrag bearbeiten",
  "status.edited": "Zuletzt am {date} bearbeitet",
  "status.edited_x_times": "{count, plural, one {{count} ×} other {{count} ×}} bearbeitet",
  "status.embed": "Code zum Einbetten",
  "status.favourite": "Favorisieren",
  "status.favourites_count": "{count, plural, one {{counter} × favorisiert} other {{counter} × favorisiert}}",
  "status.filter": "Beitrag filtern",
  "status.history.created": "{name} erstellte {date}",
  "status.history.edited": "{name} bearbeitete {date}",
  "status.load_more": "Mehr laden",
  "status.media.open": "Zum Öffnen anklicken",
  "status.media.show": "Zum Anzeigen anklicken",
  "status.media_hidden": "Inhalt ausgeblendet",
  "status.mention": "@{name} erwähnen",
  "status.more": "Mehr",
  "status.mute": "@{name} stummschalten",
  "status.mute_conversation": "Unterhaltung stummschalten",
  "status.open": "Beitrag öffnen",
  "status.pin": "Im Profil anheften",
  "status.quote": "Zitieren",
  "status.quote.cancel": "Zitat entfernen",
  "status.quote_error.blocked_account_hint.title": "Dieser Beitrag wurde ausgeblendet, weil du @{name} blockiert hast.",
  "status.quote_error.blocked_domain_hint.title": "Dieser Beitrag wurde ausgeblendet, weil du {domain} blockiert hast.",
  "status.quote_error.filtered": "Ausgeblendet wegen eines deiner Filter",
  "status.quote_error.limited_account_hint.action": "Trotzdem anzeigen",
  "status.quote_error.limited_account_hint.title": "Dieses Profil wurde von den Moderator*innen von {domain} ausgeblendet.",
  "status.quote_error.muted_account_hint.title": "Dieser Beitrag wurde ausgeblendet, weil du @{name} stummgeschaltet hast.",
  "status.quote_error.not_available": "Beitrag nicht verfügbar",
  "status.quote_error.pending_approval": "Veröffentlichung ausstehend",
  "status.quote_error.pending_approval_popout.body": "Auf Mastodon kannst du selbst bestimmen, ob du von anderen zitiert werden darfst oder nicht – oder nur nach individueller Genehmigung. Wir warten in diesem Fall noch auf die Genehmigung des ursprünglichen Profils. Bis dahin steht die Veröffentlichung des Beitrags mit dem zitierten Post noch aus.",
  "status.quote_error.revoked": "Beitrag durch Autor*in entfernt",
  "status.quote_followers_only": "Nur Follower dürfen zitieren",
  "status.quote_manual_review": "Autor*in wird deine Anfrage manuell überprüfen",
  "status.quote_noun": "Zitat",
  "status.quote_policy_change": "Ändern, wer zitieren darf",
  "status.quote_post_author": "Zitierter Beitrag von @{name}",
  "status.quote_private": "Private Beiträge können nicht zitiert werden",
  "status.quotes.empty": "Diesen Beitrag hat bisher noch niemand zitiert. Sobald es jemand tut, wird das Profil hier erscheinen.",
  "status.quotes.local_other_disclaimer": "Durch Autor*in abgelehnte Zitate werden nicht angezeigt.",
  "status.quotes.remote_other_disclaimer": "Nur Zitate von {domain} werden hier garantiert angezeigt. Durch Autor*in abgelehnte Zitate werden nicht angezeigt.",
  "status.quotes_count": "{count, plural, one {{counter} × zitiert} other {{counter} × zitiert}}",
  "status.read_more": "Gesamten Beitrag anschauen",
  "status.reblog": "Teilen",
  "status.reblog_or_quote": "Teilen oder zitieren",
  "status.reblog_private": "Erneut mit deinen Followern teilen",
  "status.reblogged_by": "{name} teilte",
  "status.reblogs.empty": "Diesen Beitrag hat bisher noch niemand geteilt. Sobald es jemand tut, wird das Profil hier erscheinen.",
  "status.reblogs_count": "{count, plural, one {{counter} × geteilt} other {{counter} × geteilt}}",
  "status.redraft": "Löschen und neu erstellen",
  "status.remove_bookmark": "Lesezeichen entfernen",
  "status.remove_favourite": "Favorisierung entfernen",
  "status.remove_quote": "Entfernen",
  "status.replied_in_thread": "Antwortete im Thread",
  "status.replied_to": "Antwortete {name}",
  "status.reply": "Antworten",
  "status.replyAll": "Allen antworten",
  "status.report": "@{name} melden",
  "status.request_quote": "Anfrage zum Zitieren",
  "status.revoke_quote": "Zitat bei @{name} entfernen",
  "status.sensitive_warning": "Inhaltswarnung",
  "status.share": "Teilen",
  "status.show_less_all": "Alles einklappen",
  "status.show_more_all": "Alles ausklappen",
  "status.show_original": "Ursprünglichen Beitrag anzeigen",
  "status.title.with_attachments": "{user} veröffentlichte {attachmentCount, plural, one {ein Medium} other {{attachmentCount} Medien}}",
  "status.translate": "Übersetzen",
  "status.translated_from_with": "Aus {lang} mittels {provider} übersetzt",
  "status.uncached_media_warning": "Vorschau noch nicht verfügbar",
  "status.unmute_conversation": "Stummschaltung der Unterhaltung aufheben",
  "status.unpin": "Vom Profil lösen",
  "subscribed_languages.lead": "Nach der Änderung werden nur noch Beiträge in den ausgewählten Sprachen in den Timelines deiner Startseite und deiner Listen angezeigt. Wähle keine Sprache aus, um alle Beiträge zu sehen.",
  "subscribed_languages.save": "Änderungen speichern",
  "subscribed_languages.target": "Abonnierte Sprachen für {target} ändern",
  "tabs_bar.home": "Startseite",
  "tabs_bar.menu": "Menü",
  "tabs_bar.notifications": "Benachrichtigungen",
  "tabs_bar.publish": "Neuer Beitrag",
  "tabs_bar.quick_links": "Schnellzugriff",
  "tabs_bar.search": "Suche",
  "tag.remove": "Entfernen",
  "terms_of_service.effective_as_of": "Gültig ab {date}",
  "terms_of_service.title": "Nutzungsbedingungen",
  "terms_of_service.upcoming_changes_on": "Anstehende Änderungen am {date}",
  "time_remaining.days": "noch {number, plural, one {# Tag} other {# Tage}}",
  "time_remaining.hours": "noch {number, plural, one {# Stunde} other {# Stunden}}",
  "time_remaining.minutes": "noch {number, plural, one {# Minute} other {# Minuten}}",
  "time_remaining.moments": "Wird gleich beendet",
  "time_remaining.seconds": "noch {number, plural, one {# Sekunde} other {# Sekunden}}",
  "trends.counter_by_accounts": "{count, plural, one {{counter} Profil} other {{counter} Profile}} {days, plural, one {seit gestern} other {in {days} Tagen}}",
  "trends.trending_now": "Aktuelle Trends",
  "ui.beforeunload": "Dein Entwurf geht verloren, wenn du Mastodon verlässt.",
  "units.short.billion": "{count} Mrd.",
  "units.short.million": "{count} Mio.",
  "units.short.thousand": "{count} Tsd.",
  "upload_area.title": "Zum Hochladen hereinziehen",
  "upload_button.label": "Bilder, Video oder Audio hinzufügen",
  "upload_error.limit": "Dateiupload-Limit überschritten.",
  "upload_error.poll": "Medien-Anhänge sind zusammen mit Umfragen nicht erlaubt.",
  "upload_error.quote": "Medien-Anhänge sind zusammen mit Zitaten nicht erlaubt.",
  "upload_form.drag_and_drop.instructions": "Drücke zum Auswählen eines Medienanhangs die Eingabe- oder Leertaste. Verwende beim Ziehen die Pfeiltasten, um den Medienanhang zur gewünschten Position zu bewegen. Drücke erneut die Eingabe- oder Leertaste, um den Medienanhang an der gewünschten Position abzulegen. Mit der Escape-Taste kannst du den Vorgang abbrechen.",
  "upload_form.drag_and_drop.on_drag_cancel": "Das Ziehen wurde abgebrochen und der Medienanhang {item} wurde abgelegt.",
  "upload_form.drag_and_drop.on_drag_end": "Der Medienanhang {item} wurde abgelegt.",
  "upload_form.drag_and_drop.on_drag_over": "Der Medienanhang {item} wurde bewegt.",
  "upload_form.drag_and_drop.on_drag_start": "Der Medienanhang {item} wurde ausgewählt.",
  "upload_form.edit": "Bearbeiten",
  "upload_progress.label": "Upload läuft …",
  "upload_progress.processing": "Wird verarbeitet …",
  "username.taken": "Dieser Profilname ist vergeben. Versuche einen anderen",
  "video.close": "Video schließen",
  "video.download": "Datei herunterladen",
  "video.exit_fullscreen": "Vollbild verlassen",
  "video.expand": "Video vergrößern",
  "video.fullscreen": "Vollbild",
  "video.hide": "Video ausblenden",
  "video.mute": "Stummschalten",
  "video.pause": "Pausieren",
  "video.play": "Abspielen",
  "video.skip_backward": "Zurückspulen",
  "video.skip_forward": "Vorspulen",
  "video.unmute": "Stummschaltung aufheben",
  "video.volume_down": "Leiser",
  "video.volume_up": "Lauter",
  "visibility_modal.button_title": "Sichtbarkeit festlegen",
  "visibility_modal.direct_quote_warning.text": "Wenn diese Einstellungen gespeichert werden, wird das eingebettete Zitat in einen Link umgewandelt.",
  "visibility_modal.direct_quote_warning.title": "Zitate können in privaten Erwähnungen nicht eingebettet werden",
  "visibility_modal.header": "Sichtbarkeit und Zitate",
  "visibility_modal.helper.direct_quoting": "Private Erwähnungen, die auf Mastodon verfasst wurden, können nicht von anderen zitiert werden.",
  "visibility_modal.helper.privacy_editing": "Die Sichtbarkeit eines bereits veröffentlichten Beitrags kann nachträglich nicht mehr geändert werden.",
  "visibility_modal.helper.privacy_private_self_quote": "Beiträge mit privaten Erwähnungen können öffentlich nicht zitiert werden.",
  "visibility_modal.helper.private_quoting": "Beiträge, die nur für deine Follower bestimmt sind und auf Mastodon verfasst wurden, können nicht von anderen zitiert werden.",
  "visibility_modal.helper.unlisted_quoting": "Sollten dich andere zitieren, werden ihre zitierten Beiträge ebenfalls nicht in den Trends und öffentlichen Timelines angezeigt.",
  "visibility_modal.instructions": "Lege fest, wer mit diesem Beitrag interagieren darf. Du hast auch die Möglichkeit, diese Einstellung auf alle zukünftigen Beiträge anzuwenden. Navigiere zu: <link>Einstellungen > Standardeinstellungen für Beiträge</link>",
  "visibility_modal.privacy_label": "Sichtbarkeit",
  "visibility_modal.quote_followers": "Nur meine Follower dürfen mich zitieren",
  "visibility_modal.quote_label": "Wer darf mich zitieren?",
  "visibility_modal.quote_nobody": "Niemand darf mich zitieren",
  "visibility_modal.quote_public": "Alle dürfen mich zitieren",
  "visibility_modal.save": "Speichern"
}
